/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

/**
 * map of filter name and filter string
 * @example {"MinOneUIVersion":"1.0.0","MaxOneUIVersion":"5.4.1","MinSmartThingsKitVersion":"1.0.0","MaxSmartThingsKitVersion":"1.2.3"}
 */
export type ClientFilters = Record<string, string>;

export interface PostinoRecommendationList {
  /**
   * Recommendation deliver interval.
   * Unit is a second.
   * Client will request recommendation list again at least after ttl time.
   * @format int64
   * @example 1366338021
   */
  ttl: number;
  /**
   * The ID of the location in which the recommendation was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId: string;
  items: PostinoRecommendation[];
}

export interface PostinoRecommendation {
  /**
   * Unique identifier of the campaign
   * @example "ST_VISION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * Unique identifier of the recommendation
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  recommendationId: string;
  /** The Card GUI information */
  template: PostinoRecommendationTemplate;
  /** The action when user clicks on the recommendation card. */
  action: PostinoRecommendationAction;
  /** map of filter name and filter string */
  clientFilters?: ClientFilters;
}

export interface PostinoRecommendationTemplate {
  id: 'TEXT_ONLY' | 'ICON_TEXT' | 'THUMBNAIL_TEXT' | 'BACKGROUND_TYPE';
  textOnly?: PostinoTextOnlyTemplate;
  iconText?: PostinoIconTextTemplate;
  thumbnailText?: PostinoThumbnailTextTemplate;
  backgroundType?: PostinoBackgroundTypeTemplate;
}

export interface RuleRequestBase {
  /** The name for the Rule. Limit 100 characters. */
  name: string;
  actions: Action[];
  /** The sequence in which the actions are to be executed (i.e. Serial (default) or Parallel). */
  sequence?: ActionSequence;
  /** The time zone ID for this Rule. This overrides the Location time zone ID, but is overridden by time zone ID provided by each operand individually. */
  timeZoneId?: string;
}

export type RuleRequest = RuleRequestBase & {
  /** Unstructured object for client to store additional data */
  meta?: object;
  /** The status of the Rule */
  status?: Status;
  /** The location where the rule is executing, either local or cloud */
  executionLocation?: ExecutionLocation;
};

export interface RuleAdhocRequest {
  /** The user-defined name of the Rule */
  name?: string;
  /** List of actions to be executed */
  actions: AdhocAction[];
  /** The sequence in which the actions are to be executed i.e. Serial or Parallel (default) */
  sequence?: ActionSequence;
  /** Unstructured object for client to store additional data */
  meta?: object;
}

export type RuleBase = RuleRequest & {
  /**
   * Unique id for the Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /**
   * The status of the Rule
   * @default "Enabled"
   */
  status?: 'Enabled' | 'Disabled';
  /** The location where the rule is executing, either local or cloud */
  executionLocation?: 'Cloud' | 'Local';
  /** Owner id */
  ownerId: string;
  /**
   * The owner of the rule is either a location or user
   * @default "Location"
   */
  ownerType: 'Location' | 'User';
  /** The creator name who create the behavior */
  creator?: Creator;
  /** Created date time */
  dateCreated: string;
  /** Last updated date time */
  dateUpdated: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:rules - the user can edit the rule
   *   <li> x:rules - the user can execute the rule
   *   <li> d:rules - the user can delete the rule
   *   </ul>
   */
  allowed?: 'w:rules' | 'x:rules' | 'd:rules';
};

export type Rule = RuleBase & {
  /** url to the scene icon */
  iconUrl?: string;
};

export interface ActionBase {
  if?: IfAction;
  sleep?: SleepAction;
  command?: CommandAction;
  every?: EveryAction;
  location?: LocationAction;
}

export interface SleepActionBase {
  duration: Interval;
}

export enum ActionType {
  Command = 'command',
  Every = 'every',
  If = 'if',
  Location = 'location',
  Scene = 'scene',
  Sleep = 'sleep',
  Notification = 'notification',
  Toggle = 'toggle',
  Group = 'group',
}

export type Action = ActionBase & {
  scene?: SceneAction;
  notification?: NotificationAction;
  toggle?: ToggleAction;
  /** Defines any combination of actions. */
  group?: GroupAction;
  limit?: LimitAction;
  type?: ActionType;
};

export type AdhocAction = {
  command?: CommandAction;
  location?: LocationAction;
  scene?: SceneAction;
  notification?: NotificationAction;
  toggle?: ToggleAction;
  type?: 'command' | 'location' | 'scene' | 'notification' | 'toggle';
};

export type IfAction = Condition & {
  then?: Action[];
  else?: Action[];
  /** The sequence in which the actions are to be executed */
  sequence?: IfActionSequence;
};

export interface CommandAction {
  devices: string[];
  commands: DeviceCommand[];
  /** The sequence in which the commands are to be executed i.e. Serial or Parallel (default) */
  sequence?: CommandSequence;
}

export type SleepAction = SleepActionBase & {
  strategy?: Strategy;
};

export interface EveryAction {
  interval?: Interval;
  specific?: DateTimeOperand;
  actions: Action[];
  /** The sequence in which the actions are to be executed i.e. Serial (default) or Parallel */
  sequence?: ActionSequence;
}

export interface LocationAction {
  /**
   * locationId is required for "User level rule". (It's optional for "Location level rule")
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  mode?: string;
  security?: SecurityState;
}

export interface LimitAction {
  /**
   * Unique id for the action
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id?: string;
  /** Number of times the action can execute within the period */
  count: number;
  /** The period of time */
  period: 'Minute' | 'Hour' | 'Day' | 'Week' | 'Month' | 'Lifetime';
  /**
   * Number of period interval. Must be greater than or equal to 1. \n\n
   * If period == Minute then periodInterval can be 1 ~ 1440 \n\n
   * If period == Hour then periodInterval can be 1 ~ 8760 \n\n
   * If period == Day then periodInterval can be 1 ~ 4380 \n\n
   * If period == Week then periodInterval can be 1 ~ 624 \n\n
   * If period == Month then periodInterval can be 1 ~ 144 \n\n
   * @min 1
   */
  periodInterval?: number;
  actions: Action[];
  sequence?: ActionSequence;
}

export interface NotificationAction {
  push?: PushNotification;
  audio?: AudioNotification;
  custom?: CustomNotification;
  sms?: SmsNotification;
  image?: ImageNotification;
  type?: NotificationType;
}

export interface ToggleAction {
  devices: string[];
  component: string;
  capability: string;
  attribute: string;
}

/** Defines any combination of actions. */
export interface GroupAction {
  actions: Action[];
  /** The sequence in which the actions are to be executed i.e. Serial (default) or Parallel */
  sequence?: ActionSequence;
}

export enum NotificationType {
  Push = 'push',
  Audio = 'audio',
  Custom = 'custom',
  Sms = 'sms',
  Image = 'image',
}

export interface PushNotification {
  /** Push notification title */
  title?: string;
  /** Push notification message */
  message: string;
  target?: NotificationTarget;
}

export interface AudioNotification {
  /** Audio notification title */
  title?: string;
  /** Audio notification message */
  message: string;
  /** Device list where audio to be played */
  devices: string[];
  /**
   * Number of times to repeat the message, default is one
   * @format int64
   * @min 1
   * @max 10
   */
  repeat?: number;
  /**
   * Volume level
   * @format int64
   * @min 1
   * @max 100
   */
  level?: number;
  ttsProvider?: TtsProvider;
}

export interface TtsProvider {
  /** Voice provider name, Bixby (default), Polly */
  provider?: string;
  /** Language code, “en-us” (default), “ko-kr” */
  locale?: string;
  /** Voice code, “M01”, “M02” (default), “F05” */
  profile?: string;
  /** Audio encoding properties that will be used by TTS service to prepare the audio */
  output?: Output;
}

export interface Output {
  /** Encoding type. Default “PCM” */
  format?: string;
  /** Bitrate of the audio. Default 24 */
  bitrate?: number;
  /** Channel supported. Default “Mono” */
  channel?: string;
  /** Frequency supported. Default 24000 */
  freq?: number;
}

export interface CustomNotification {
  /** Default(when recipientType is not filled out or 'DEVICE' ),Device ids that would receive this noti(mobile client id) or that is used at 'Rule'(mobile presence id). If recipientType is 'LOCATION', recipients should be location id. If recipientType is 'USER' recipients should be user uuid. */
  recipients: string[];
  /** Custom notification message in pabal request format */
  message: object;
  /** DEVICE - recipients must be 'deviceId' LOCATION - recipients must be 'locationId' / USER - recipients must be 'userUuid' */
  recipientType?: RecipientType;
}

/** @example {"recipients":["sms:+19999999999"]} */
export interface SmsNotification {
  /** Sms notification message */
  message: string;
  /** List of recipients phone number. Format - ['sms:<Phone Number>'] */
  recipients: string[];
  /** Installed App Id to be added in the response */
  entityId?: string;
  /** Installed app config ID to be added in the response */
  messageGroupSet?: string;
  /** Response from Hermes API Client, To be included in the Response */
  messageGroupKey?: string;
}

/** @example {"device":{"devices":["device1"],"component":"main","capability":"imageCapture","attribute":"image","subscriptionMode":"Never"}} */
export interface ImageNotification {
  /** Image notification title */
  title?: string;
  /** Image notification message. Would be sent when image capture fails. */
  message: string;
  /** Camera list that would capture and produce event. Event musth be mentioned and triggerMode must be "NEVER" */
  device: DeviceOperand;
  /** Mention that this action is for only sending image notification or sending image take device command together. Default false. */
  onlyNoti?: boolean;
  target?: NotificationTarget;
}

export interface NotificationTarget {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  locationId?: string;
  userUuids?: string[];
}

export enum RecipientType {
  DEVICE = 'DEVICE',
  LOCATION = 'LOCATION',
  USER = 'USER',
}

export interface SceneAction {
  scenes: string[];
  sequence?: SceneSequence;
}

export interface ConditionBase {
  and?: Condition[];
  or?: Condition[];
  not?: Condition;
  equals?: EqualsCondition;
  greaterThan?: GreaterThanCondition;
  greaterThanOrEquals?: GreaterThanOrEqualsCondition;
  lessThan?: LessThanCondition;
  lessThanOrEquals?: LessThanOrEqualsCondition;
  between?: BetweenCondition;
  changes?: ChangesCondition;
  remains?: RemainsCondition;
  /** `Deprecated` A condition that returns true if its evaluation would return true within the specified duration. */
  was?: WasCondition;
}

export interface BasicCondition {
  and?: Condition[];
  or?: Condition[];
  not?: Condition;
  equals?: EqualsCondition;
  greaterThan?: GreaterThanCondition;
  greaterThanOrEquals?: GreaterThanOrEqualsCondition;
  lessThan?: LessThanCondition;
  lessThanOrEquals?: LessThanOrEqualsCondition;
  between?: BetweenCondition;
}

export enum BasicConditionType {
  And = 'and',
  Between = 'between',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEquals = 'greaterThanOrEquals',
  LessThan = 'lessThan',
  LessThanOrEquals = 'lessThanOrEquals',
  Not = 'not',
  Or = 'or',
}

export enum ConditionType {
  And = 'and',
  Between = 'between',
  Changes = 'changes',
  DropsBelow = 'dropsBelow',
  DropsToOrBelow = 'dropsToOrBelow',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEquals = 'greaterThanOrEquals',
  LessThan = 'lessThan',
  LessThanOrEquals = 'lessThanOrEquals',
  Not = 'not',
  Or = 'or',
  Remains = 'remains',
  RemainsEqual = 'remainsEqual',
  RisesAbove = 'risesAbove',
  RisesToOrAbove = 'risesToOrAbove',
  Was = 'was',
  WasEqual = 'wasEqual',
  OneAppLeadTime = 'oneAppLeadTime',
}

export type Condition = ConditionBase & {
  /** `Deprecated` */
  dropsBelow?: DropsBelowCondition;
  /** `Deprecated` */
  dropsToOrBelow?: DropsToOrBelowCondition;
  /** `Deprecated` */
  risesAbove?: RisesAboveCondition;
  /** `Deprecated` */
  risesToOrAbove?: RisesToOrAboveCondition;
  remains?: RemainsCondition;
  /** `Deprecated` */
  remainsEqual?: RemainsEqualCondition;
  /** `Deprecated` */
  wasEqual?: WasEqualCondition;
  /** `Deprecated` */
  oneAppLeadTime?: OneAppLeadTimeCondition;
  type?: ConditionType;
};

export interface SingleOperandCondition {
  left: Operand;
  aggregation?: ConditionAggregationMode;
}

export interface SimpleCondition {
  left: Operand;
  right: Operand;
  aggregation?: ConditionAggregationMode;
}

export type StandardCondition = SimpleCondition & {
  /** Determines whether or not to track the evaluation state of the operation it contains, trigger the condition when the state of the inner operation transitions from false to true. Default is false. */
  changesOnly?: boolean;
};

export type TimedSimpleCondition = SimpleCondition & {
  interval: Interval;
};

export type EqualsCondition = StandardCondition;

export type GreaterThanCondition = StandardCondition;

export type GreaterThanOrEqualsCondition = StandardCondition;

export type LessThanCondition = StandardCondition;

export type LessThanOrEqualsCondition = StandardCondition;

export interface BetweenCondition {
  value: Operand;
  start: Operand;
  end: Operand;
  aggregation?: ConditionAggregationMode;
  /** Determines whether or not to track the evaluation state of the operation it contains, trigger the condition when the state of the inner operation transitions from false to true. Default is false. */
  changesOnly?: boolean;
}

/** `Deprecated` */
export type DropsBelowCondition = SimpleCondition;

/** `Deprecated` */
export type DropsToOrBelowCondition = SimpleCondition;

/** `Deprecated` */
export type RisesAboveCondition = SimpleCondition;

/** `Deprecated` */
export type RisesToOrAboveCondition = SimpleCondition;

/** `Deprecated` */
export type RemainsEqualCondition = TimedSimpleCondition;

/** `Deprecated` */
export type WasEqualCondition = TimedSimpleCondition;

/** `Deprecated` */
export type OneAppLeadTimeCondition = TimedSimpleCondition;

/** A condition that returns true when its evaluation resolves to true and the previous evaluation resolved to false. */
export type ChangesConditionBase = (BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  operand?: Operand;
}) & {
  type?: BasicConditionType;
};

export type ChangesCondition = ChangesConditionBase;

/** A condition that returns true if its evaluation is true after the specified duration. */
export type RemainsConditionBase = (BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  operand?: Operand;
  duration: Interval;
  /** Determines whether the condition should return true in subsequent executions after initially satisfied. Default is false. */
  latching?: boolean;
}) & {
  type?: BasicConditionType;
};

export type RemainsCondition = RemainsConditionBase;

/** `Deprecated` A condition that returns true if its evaluation would return true within the specified duration. */
export type WasCondition = BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  duration: Interval;
  operand?: Operand;
};

export interface OperandBase {
  boolean?: boolean;
  /** @format double */
  decimal?: number;
  /** @format int64 */
  integer?: number;
  string?: string;
  array?: ArrayOperand;
  map?: MapOperand;
  device?: DeviceOperand;
  location?: LocationOperand;
  date?: DateOperand;
  /** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
  time?: TimeOperand;
  datetime?: DateTimeOperand;
}

export enum OperandType {
  Array = 'array',
  Boolean = 'boolean',
  Date = 'date',
  Datetime = 'datetime',
  Decimal = 'decimal',
  Device = 'device',
  Integer = 'integer',
  Location = 'location',
  Map = 'map',
  String = 'string',
  IndexedString = 'indexedString',
  Time = 'time',
}

export type Operand = OperandBase & {
  indexedString?: IndexedStringOperand;
  type?: OperandType;
};

export interface ArrayOperand {
  operands: Operand[];
  aggregation?: OperandAggregationMode;
}

export interface DateOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  reference?: DateReference;
}

export interface DateTimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export interface DeviceOperand {
  devices: string[];
  component: string;
  capability: string;
  attribute: string;
  path?: string;
  aggregation?: OperandAggregationMode;
  trigger?: TriggerMode;
}

export interface LocationOperand {
  /**
   * Required for User level rule, optional for Location level in request. Will always be present in response for both.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Only valid for the attribute 'WeatherAlertSeverity' */
  postalCode?: string;
  attribute: LocationAttribute;
  trigger?: TriggerMode;
}

export type MapOperand = Record<string, Operand>;

/** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
export interface TimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export interface IndexedStringOperand {
  value: Operand;
  indices: string[];
}

export enum Sequence {
  Serial = 'Serial',
  Parallel = 'Parallel',
}

export interface ActionSequence {
  actions?: Sequence;
}

export interface CommandSequence {
  commands?: Sequence;
  devices?: Sequence;
}

export interface IfActionSequence {
  then?: Sequence;
  else?: Sequence;
}

export interface SceneSequence {
  scenes?: Sequence;
}

export enum ExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Ignored = 'Ignored',
}

export enum IfExecutionResult {
  True = 'True',
  False = 'False',
}

export enum CommandExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Offline = 'Offline',
}

/** The result of a if action execution */
export interface IfActionExecutionResult {
  result: IfExecutionResult;
}

/** The result of a command action execution */
export interface CommandActionExecutionResult {
  result: CommandExecutionResult;
  /**
   * Device ID for device actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
}

/** The result of a location action execution */
export interface LocationActionExecutionResult {
  result: ExecutionResult;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/** The result of a sleep action execution */
export interface SleepActionExecutionResult {
  result: ExecutionResult;
}

/** The result of a limit action execution */
export interface LimitActionExecutionResult {
  result: ExecutionResult;
}

/** The result of an action execution */
export interface ActionExecutionResultBase {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  actionId: string;
  /** The result of a if action execution */
  if?: IfActionExecutionResult;
  /** The result of a location action execution */
  location?: LocationActionExecutionResult;
  command?: CommandActionExecutionResult[];
  /** The result of a sleep action execution */
  sleep?: SleepActionExecutionResult;
}

/** The result of a scene action execution */
export interface SceneActionExecutionResult {
  result: ExecutionResult;
  /**
   * Scene ID for scene actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

/** The result of a notification action execution */
export interface NotificationActionExecutionResult {
  result: ExecutionResult;
  type: NotificationType;
}

export enum LightEffectExecutionStatus {
  Started = 'Started',
  Stopped = 'Stopped',
  Canceled = 'Canceled',
}

export type ActionExecutionResult = ActionExecutionResultBase & {
  type: ActionType;
  /** The result of a limit action execution */
  limit?: LimitActionExecutionResult;
  scene?: SceneActionExecutionResult[];
  /** The result of a notification action execution */
  notification?: NotificationActionExecutionResult;
};

/** The result of a Rule execution */
export interface RuleExecutionResponse {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  executionId: string;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  id: string;
  result: ExecutionResult;
  actions?: ActionExecutionResult[];
}

export interface DeviceCommand {
  component: string;
  capability: string;
  command: string;
  arguments?: Operand[];
}

/** @default "Any" */
export enum ConditionAggregationMode {
  Any = 'Any',
  All = 'All',
}

/** @default "None" */
export enum OperandAggregationMode {
  None = 'None',
}

/** @default "Auto" */
export enum TriggerMode {
  Auto = 'Auto',
  Always = 'Always',
  Never = 'Never',
}

export enum LocationAttribute {
  FineDust = 'FineDust',
  FineDustIndex = 'FineDustIndex',
  Humidity = 'Humidity',
  Mode = 'Mode',
  Security = 'Security',
  Temperature = 'Temperature',
  TemperatureC = 'TemperatureC',
  TemperatureF = 'TemperatureF',
  UltraFineDust = 'UltraFineDust',
  UltraFineDustIndex = 'UltraFineDustIndex',
  Weather = 'Weather',
  WeatherAlertSeverity = 'WeatherAlertSeverity',
}

export enum ArmState {
  ArmedStay = 'ArmedStay',
  ArmedAway = 'ArmedAway',
  Disarmed = 'Disarmed',
}

export interface SecurityState {
  armState: ArmState;
  monitoring?: boolean;
}

export enum DateReference {
  Today = 'Today',
}

export enum TimeReference {
  Now = 'Now',
  Midnight = 'Midnight',
  Sunrise = 'Sunrise',
  Noon = 'Noon',
  Sunset = 'Sunset',
}

export enum DayOfWeek {
  Sun = 'Sun',
  Mon = 'Mon',
  Tue = 'Tue',
  Wed = 'Wed',
  Thu = 'Thu',
  Fri = 'Fri',
  Sat = 'Sat',
}

export interface Interval {
  value: Operand;
  unit: IntervalUnit;
}

export enum IntervalUnit {
  Second = 'Second',
  Minute = 'Minute',
  Hour = 'Hour',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}

/** @default "Interrupt" */
export enum Strategy {
  Ignore = 'Ignore',
  Interrupt = 'Interrupt',
}

/** An array of Rules */
export interface PagedRules {
  items?: Rule[];
  _links?: Links;
}

/**
 * The status of the Rule
 * @default "Enabled"
 */
export enum Status {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

/** The location where the rule is executing, either local or cloud */
export enum ExecutionLocation {
  Cloud = 'Cloud',
  Local = 'Local',
}

/**
 * The owner of the rule is either a location or user
 * @default "Location"
 */
export enum OwnerType {
  Location = 'Location',
  User = 'User',
}

/** The creator name who create the behavior */
export enum Creator {
  SMARTTHINGS = 'SMARTTHINGS',
  ARB = 'ARB',
  RECIPE = 'RECIPE',
  UNDEFINED = 'UNDEFINED',
}

export interface PostinoTextOnlyTemplate {
  background: {
    /** @example "ff8080" */
    color: string;
  };
  subTitle?: {
    /**
     * The recommendation card subtitle displayed on the client.
     * @example "Sub Title Example"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff8080" */
    textColor: string;
  };
  button: {
    /** @example "View Detail" */
    text: string;
    /** @example "ff8080" */
    textColor: string;
  };
  dismissButton: {
    /** @example "ff8080" */
    iconColor: string;
  };
}

export interface PostinoIconTextTemplate {
  background: {
    /** @example "ff8080" */
    color: string;
  };
  subTitle?: {
    /**
     * The recommendation card subtitle displayed on the client.
     * @example "Sub Title Example"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff8080" */
    textColor: string;
    /** @example "https://example.com" */
    iconUrl?: string;
    /** @example "https://example-animation.com" */
    animationIconUrl?: string;
  };
  button: {
    /** @example "View Detail" */
    text: string;
    /** @example "ff8080" */
    textColor: string;
  };
  dismissButton: {
    /** @example "ff8080" */
    iconColor: string;
  };
}

export interface PostinoThumbnailTextTemplate {
  background: {
    /** @example "ff8080" */
    color: string;
  };
  subTitle?: {
    /**
     * The recommendation card subtitle displayed on the client.
     * @example "Sub Title Example"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff8080" */
    textColor: string;
    /** @example "https://example.com" */
    iconUrl: string;
  };
  button: {
    /** @example "View Detail" */
    text: string;
    /** @example "ff8080" */
    textColor: string;
  };
  dismissButton: {
    /** @example "ff8080" */
    iconColor: string;
  };
}

export interface PostinoBackgroundTypeTemplate {
  background: {
    /** @example "https://example.com" */
    imageUrl: string;
  };
  subTitle?: {
    /**
     * The recommendation card subtitle displayed on the client.
     * @example "Sub Title Example"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff8080" */
    textColor: string;
  };
  dismissButton: {
    /** @example "ff8080" */
    iconColor: string;
  };
  /** Dark mode setting. subTitle, body etc. can be added to the properties when needed to support in the future. */
  darkMode?: PostinoDarkMode;
  /** Wide screen mode setting. subTitle, body etc. can be added to the properties when needed to support in the future. */
  wideMode?: PostinoWideMode;
}

/** Dark mode setting. subTitle, body etc. can be added to the properties when needed to support in the future. */
export interface PostinoDarkMode {
  background?: {
    /** @example "http://darkmode-example.com" */
    imageUrl?: string;
  };
}

/** Wide screen mode setting. subTitle, body etc. can be added to the properties when needed to support in the future. */
export interface PostinoWideMode {
  background?: {
    /** @example "http://wide-lightmode-example.com" */
    lightModeImageUrl?: string;
    /** @example "http://wide-darkmode-example.com" */
    darkModeImageUrl?: string;
  };
}

export interface PostinoRecommendationAction {
  type:
    | 'SCENE'
    | 'DEVICE_GROUP'
    | 'WEB_LINK'
    | 'SERVICE_PLUGIN'
    | 'ENDPOINT_APP'
    | 'GROOVY_SMART_APP'
    | 'DEEP_LINK'
    | 'ROUTINE'
    | 'NO_ACTION'
    | 'INSTANT_VIEW';
  /** Web link action */
  webLink?: PostinoWebLinkAction;
  /** Deep link action */
  deepLink?: PostinoDeepLinkAction;
  /** Device Plugin Action */
  servicePlugin?: PostinoServicePluginAction;
  /** Endpoint App Action */
  endpointApp?: PostinoEndpointAppAction;
  /** Groovy Smart App Action */
  groovySmartApp?: PostinoGroovySmartAppAction;
  /** Scene action */
  scene?: PostinoSceneAction;
  /** Device Group Action */
  deviceGroup?: PostinoDeviceGroupAction;
  /** Routine action */
  routine?: PostinoRoutineAction;
  /** Instant view action */
  instantView?: PostinoInstantViewAction;
}

/** Web link action */
export interface PostinoWebLinkAction {
  /** @example "https://www.smartthings.com/" */
  uri: string;
}

/** Deep link action */
export interface PostinoDeepLinkAction {
  /** @example "samsungconnect://launch?action=dashboard" */
  uri: string;
}

/** Device Plugin Action */
export interface PostinoServicePluginAction {
  name: string;
  /** Localized display name. */
  displayName: string;
  /** @example "wwst://com.samsung.hcw" */
  pluginId: string;
  /**
   * The ID of the Endpoint App Template
   * @example "847c3e31-c5d6-4623-953a-2b757f6f1ad9"
   */
  endpointAppId: string;
  /**
   * This filed is existed only 'silentInstall' is true.
   * @example "r:devices:*|w:devices:*|x:devices:*"
   */
  permissions?: string;
  /** @default false */
  silentInstall: boolean;
  /**
   * This field is an custom data area. This structure is a map. A plugin will parse it.
   * @example {"uri":"launch_hcw_setting"}
   */
  data: object;
}

/** Endpoint App Action */
export interface PostinoEndpointAppAction {
  /**
   * Human readable name of the smart app action.
   * @example "Smart Lighting"
   */
  name: string;
  /** Localized display name. */
  displayName: string;
  /** The ID of the Endpoint App Template. */
  endpointAppId: string;
}

/** Groovy Smart App Action */
export interface PostinoGroovySmartAppAction {
  /**
   * Human readable name of the smart app action.
   * @example "Smart Lighting"
   */
  name: string;
  /** Localized display name. */
  displayName: string;
  /**
   * The unique name of the Smart App
   * @example "Smart Lighting"
   */
  smartAppName: string;
  /** @example "smartsolutionsv2/lighting" */
  smartAppNamespace: string;
}

/** Scene action */
export interface PostinoSceneAction {
  /** @example "Turn on power swich and adjust dimming value with 50" */
  name: string;
  /** Localized display name. */
  displayName: string;
  actions: PostinoScene[];
}

/** Routine action */
export interface PostinoRoutineAction {
  /**
   * Title of the routine template
   * @example "Arriving and Leaving"
   */
  presetTitle: string;
  /**
   * Unique identifier of the routine template
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  routineTemplateId: string;
  /**
   * If rule version is lower then do not show the preset at the app
   * @example "0.0.1"
   */
  ruleVersion: string;
  /** Recommended routine body template(from rabbit) */
  routineTemplate: RuleRequest;
}

/** Instant view action */
export interface PostinoInstantViewAction {
  type: 'TEXT_ONLY' | 'TEXT_IMAGE' | 'TEXT_ANIMATION_IMAGE';
  /** Text only instant view action */
  textOnly?: PostinoTextOnlyInstantViewAction;
  /** Text image instant view action */
  textImage?: PostinoTextImageInstantViewAction;
  /** Text image animation instant view action */
  textAnimationImage?: PostinoTextImageAnimationInstantViewAction;
}

/** Text only instant view action */
export interface PostinoTextOnlyInstantViewAction {
  subTitle: PostinoInstantViewActionSubtitle;
  body: PostinoTextOnlyInstantViewBodyAction;
  button?: PostinoTextOnlyInstantViewButtonAction;
  link: PostinoInstantViewActionLink;
}

/** Text image instant view action */
export interface PostinoTextImageInstantViewAction {
  subTitle: PostinoInstantViewActionSubtitle;
  body: PostinoTextImageInstantViewBodyAction;
  button?: PostinoTextOnlyInstantViewButtonAction;
  link: PostinoInstantViewActionLink;
}

/** Text image animation instant view action */
export interface PostinoTextImageAnimationInstantViewAction {
  subTitle: PostinoInstantViewActionSubtitle;
  body: PostinoTextImageAnimationInstantViewBodyAction;
  button?: PostinoTextOnlyInstantViewButtonAction;
  link: PostinoInstantViewActionLink;
}

export interface PostinoInstantViewActionSubtitle {
  /** @example "Sub title" */
  text: string;
}

export interface PostinoTextOnlyInstantViewBodyAction {
  /** @example "<p>Explore Weblink: <a href="https://www.samsung.com">Click here</a></p>" */
  text: string;
}

export interface PostinoTextOnlyInstantViewButtonAction {
  /** @example "button text" */
  text: string;
}

export interface PostinoTextImageInstantViewBodyAction {
  /** @example "<p>Explore Weblink: <a href="https://www.samsung.com">Click here</a></p>" */
  text: string;
  imageUrl: PostinoTextImageInstantViewBodyUrlAction;
}

export interface PostinoTextImageInstantViewBodyUrlAction {
  /** @example "http://lightmode-example.com" */
  lightModeImageUrl: string;
  /** @example "http://darkmode-example.com" */
  darkModeImageUrl: string;
}

export interface PostinoTextImageAnimationInstantViewBodyAction {
  /** @example "<p>Explore Weblink: <a href="https://www.samsung.com">Click here</a></p>" */
  text: string;
  animationImageUrl: PostinoTextImageAnimationInstantViewBodyUrlAction;
}

export interface PostinoTextImageAnimationInstantViewBodyUrlAction {
  /** @example "http://lightmode-example.com" */
  lightModeAnimationImageUrl: string;
  /** @example "http://darkmode-example.com" */
  darkModeAnimationImageUrl: string;
}

export interface PostinoInstantViewActionLink {
  type: 'DEEP_LINK' | 'NO_ACTION';
  deepLink?: PostinoInstanViewActionLinkDeepLinkType;
}

export interface PostinoInstanViewActionLinkDeepLinkType {
  /** @example "samsungconnect://launch?action=onboarding" */
  uri: string;
}

/** Scene */
export interface PostinoScene {
  /**
   * type of the action.
   * @example "DEVICE"
   */
  actionType: 'DEVICE';
  /** Scene */
  device?: PostinoSceneDeviceAction;
}

/** Scene */
export interface PostinoSceneDeviceAction {
  /**
   * OCF device type.
   * @example "oic.d.light"
   */
  deviceType: string;
  /**
   * The name of the component on this device.
   * The component must be valid for the device.
   * @example "main"
   */
  component: string;
  /**
   * Capability that this command relates to.
   * This must be a capability of the component.
   * @example "switch"
   */
  capability: string;
  /**
   * Name of the command, this must be valid for the capability.
   * @example "on"
   */
  command: string;
  /**
   * Arguments of the command.
   * All the required arguments defined in the capability's command argument definition must be provided.
   * The type of the arguments are dependent on the type of the capability's command argument.
   * Please refer to the capabilities definition at https://smartthings.developer.samsung.com/develop/api-ref/capabilities.html
   * @example {"value":50}
   */
  arguments: object;
}

/** Device Group Action */
export interface PostinoDeviceGroupAction {
  /** Localized display name. */
  displayName: string;
  /** @example "oic.d.light" */
  deviceType: string;
}

export interface PostinoRecommendationListInternal {
  /**
   * Recommendation deliver interval.
   * Unit is a second.
   * Client will request recommendation list again at least after ttl time.
   * @format int64
   * @example 1366338021
   */
  ttl: number;
  /**
   * The ID of the location in which the recommendation was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId: string;
  items: PostinoRecommendationInternal[];
}

export interface PostinoRecommendationInternal {
  /**
   * Unique identifier of the campaign
   * @example "ST_VISION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * Unique identifier of the recommendation
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  recommendationId: string;
  /** map of filter name and filter string */
  clientFilters?: ClientFilters;
  /** The Card GUI information */
  template: PostinoRecommendationTemplate;
  /** The action when user clicks on the recommendation card. */
  action: PostinoRecommendationActionInternal;
}

export interface PostinoRecommendationHistoryInternal {
  /**
   * Unique identifier of the campaign
   * @example "ST_VISION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * Unique identifier of the recommendation
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  recommendationId: string;
  /** Type of the recommendation */
  recommendationType: 'PROMOTION' | 'FEATURE' | 'LIST_ONLY';
  /**
   * The ID of the location in which the recommendation was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId: string;
  /** map of filter name and filter string */
  clientFilters?: ClientFilters;
  /** The Card GUI information */
  template: PostinoRecommendationTemplate;
  /** The action when user clicks on the recommendation card. */
  action: PostinoRecommendationAction;
  /**
   * Start date and time of campaign. https://tools.ietf.org/html/rfc3339#section-5.6
   * @format date-time
   */
  startTime: string;
  /**
   * Client/server could choose only display highest priority recommendation when multiple are returned.
   * Lower number means higher priority.
   */
  priority: number;
}

/**
 * Recommendation action object.
 * For each action type, an additional map attribute will be present which holds action specific content.
 * The map attribute name will be Camel Case of the type value.
 * @example {"type":"DEVICE_GROUP","deviceGroup":{"displayName":"Lighting Group 1","deviceType":"oic.d.light"}}
 */
export interface PostinoRecommendationActionInternal {
  type:
    | 'SCENE'
    | 'DEVICE_GROUP'
    | 'SMART_APP'
    | 'WEB_LINK'
    | 'PLUGIN'
    | 'DEEP_LINK'
    | 'ROUTINE'
    | 'NO_ACTION'
    | 'INSTANT_VIEW';
  [key: string]: any;
}

export interface RecommendationCampaign {
  /**
   * Campaign Id generated from recommendation Admin Portal
   * @example "MISSED_ACTION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * Recommendation Id to deliver, if set postino do not choose the recommendation to deliver
   * @example "0c89ea14-7ea7-4ba5-af62-80fa93073b66"
   */
  recommendationId?: string;
  /**
   * Time to Live in utc milliseconds
   * @format int64
   * @example 1573526524641
   */
  ttl?: number;
  /** for admin portal use, if true delivery the recommendation without campaign status check */
  preview?: boolean;
  /** A flag to describe if it is an event driven recommendation. (e.g. onboarding recommendation) */
  eventDriven?: boolean;
  users: RecommendationUserDetail[];
}

export interface RecommendationUserDetail {
  /** @example "78d2558e-f13f-11e9-81b4-2a2ae2dbcce4" */
  stUserId: string;
  /**
   * Optional. Installed app id used in Pabal deepLink
   * @example "66d2558e-f13f-11e9-81b4-2a2ae2dbcca2"
   */
  installedAppId?: string;
  /** @example "88d2558e-f13f-11e9-81b4-2a2ae2dbcca2" */
  locationId: string;
  /** @example "USA" */
  countryCode?: string;
  /**
   * Region where the user belongs to. (na, ap, eu)
   * @example "na"
   */
  region?: string;
}

export type RecommendationCampaignWithAction = {
  action?: 'INSERT' | 'DELETE';
} & RecommendationCampaign;

export interface PostinoRecommendationPreference {
  /** If it is false, recommendations wont be returned by getRecommendations API. */
  enableRecommendations?: boolean;
}

export interface PostinoGDPRRequest {
  /**
   * samsung user id
   * @example "uo0z1tkd5j"
   */
  saguid: string;
  /**
   * gdpr transaction_id for the request, unique for every request
   * @example "request-uuid-1"
   */
  gdpr_id: string;
  /**
   * gdpr title for the request
   * @example "Right to restrict"
   */
  title: string;
  /**
   * url to send callback to
   * @example "www.url.com"
   */
  callback_url?: string;
}

export interface SendCampaignEmailsRequest {
  /**
   * Campaign Id
   * @example "MISSED_ACTION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * List of email to be sent for the specified campaign
   * @maxItems 1000
   * @minItems 1
   */
  emails: {
    /**
     * recipient email address
     * @example "bob@smith.com"
     */
    recipientEmail: string;
    /**
     * recipient name
     * @example "Robert Smith"
     */
    recipientName: string;
    /**
     * email content locale
     * @example "en-US"
     */
    locale: string;
    /** any email template variables */
    data?: object;
  }[];
}

export interface PostinoPresetAutomationList {
  items: PresetAutomation[];
}

export interface PresetAutomation {
  /**
   * Unique ID of the preset automation
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "1bffab19-2471-4933-8980-c8fe316e75bc"
   */
  automationId: string;
  /** Preset automation category type */
  category: CategoryEnum;
  /** Preset automation scenario type */
  scenario?: ScenarioEnum;
  /**
   * Localized automation title
   * @example "Rain alert"
   */
  name: string;
  /** Conditions for activating the automation */
  conditions: {
    /** Preset automation condition relationship type */
    relationship?: RelationshipEnum;
    cards?: AutomationCard[];
  };
  /** Actions to be executed for an automation */
  actions: {
    cards?: AutomationCard[];
  };
}

/** Automation card details */
export interface AutomationCard {
  /** Automation card type */
  type: AutomationCardTypeEnum;
  /**
   * URI of automation card icon
   * @format uri
   */
  icon: string;
  attributes: AutomationCardAttribute[];
  /** Execution sequence of the automation card */
  sequence: number;
}

/** Attribute of an automation card */
export interface AutomationCardAttribute {
  /** Attribute name */
  attribute: string;
  /** Attribute value */
  value?: string;
}

/**
 * Preset automation category type
 * @example "MATCHED"
 */
export enum CategoryEnum {
  MATCHED = 'MATCHED',
  NOT_MATCHED = 'NOT_MATCHED',
}

/**
 * Preset automation scenario type
 * @example "NO_DEVICE"
 */
export enum ScenarioEnum {
  NO_DEVICE = 'NO_DEVICE',
  TIME_DEVICE = 'TIME_DEVICE',
  DEVICE_NOTIFY = 'DEVICE_NOTIFY',
  DEVICE_DEVICE = 'DEVICE_DEVICE',
  TIME_DEVICE_DEVICE = 'TIME_DEVICE_DEVICE',
  MEMBER_DEVICE = 'MEMBER_DEVICE',
}

/**
 * Preset automation condition relationship type
 * @example "OR"
 */
export enum RelationshipEnum {
  OR = 'OR',
  AND = 'AND',
}

/**
 * Automation card type
 * @example "WEATHER"
 */
export enum AutomationCardTypeEnum {
  WEATHER = 'WEATHER',
  MEMBER = 'MEMBER',
  TIME = 'TIME',
  DEVICE = 'DEVICE',
  NOTIFICATION = 'NOTIFICATION',
}

/** Notification status */
export interface NotificationStatus {
  /** Notification status */
  status: NotificationStatusEnum;
}

/** Notification status */
export enum NotificationStatusEnum {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
}

export interface PostinoNotificationList {
  items: PostinoNotification[];
}

export interface PostinoNotification {
  /**
   * Unique identifier of the notification
   * @example "f99c6684-9b93-45ea-ae5a-9d96414441e4"
   */
  pushRecommendationId: string;
  /**
   * The ID of the location in which the push recommendation was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId: string;
  /**
   * Start date and time of notification. https://tools.ietf.org/html/rfc3339#section-5.6
   * @format date-time
   */
  startTime: string;
  /** The Card Text & Icon information */
  template: PostinoNotificationTemplate;
  /** The action when user clicks on the push recommendation card. */
  action: PostinoRecommendationAction;
  /** map of filter name and filter string */
  clientFilters?: ClientFilters;
}

export interface PostinoNotificationTemplate {
  /**
   * The recommendation card text displayed on the client.
   * @example "Did you know you can make your home safer with 'ST Vision'?"
   */
  text: string;
  /** @example "https://example.com" */
  iconUrl?: string;
}

export interface RecommendationListResponse {
  items?: PostinoRecommendationHistoryInternal[];
}

export interface PostinoPresetRoutinesList {
  /**
   * The ID of the location in which the routines was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId?: string;
  items: PostinoPresetCategory[];
}

export interface PostinoPresetCategory {
  /**
   * Unique identifier of the preset category
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  categoryId: string;
  /**
   * Translated text for category title(Based on Accept-Language Header)
   * @example "Arriving and Leaving"
   */
  categoryTitle: string;
  /**
   * Translated text for category description(Based on Accept-Language Header)
   * @example "Description for Arriving and Leaving."
   */
  categoryDescription: string;
  /**
   * image URL for category icon
   * @example "http://icon-example.com"
   */
  categoryIcon: string;
  /** CategoryImage of light and dark CategoryImageUrl. */
  categoryImage: PostinoPresetCategoryImage;
  /** List of Preset */
  preset: PostinoPreset[];
}

/** CategoryImage of light and dark CategoryImageUrl. */
export interface PostinoPresetCategoryImage {
  /** @example "http://lightcategoryimage-example.com" */
  lightCategoryImageUrl: string;
  /** @example "http://darkcategoryimage-example.com" */
  darkCategoryImageUrl: string;
}

export interface PostinoPreset {
  /**
   * Unique identifier of the preset
   * @example "522e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  presetId: string;
  /** @example "431e28ca-c33b-49c9-a5a1-dce40e41f8a4" */
  routineTemplateId: string;
  /**
   * Translated text for preset title(Based on Accept-Language Header)
   * @example "Notify when someone arrive"
   */
  presetTitle: string;
  /**
   * Translated text for preset description(Based on Accept-Language Header)
   * @example "Description for Notify when someone arrive."
   */
  presetDescription: string;
  /**
   * version of rule
   * @example "0.0.1"
   */
  ruleVersion: string;
  /** Recommended routine body template(from rabbit) */
  routineTemplate: RuleRequest;
}

/** Client Triggered Recommendation status */
export interface ClientRecommendationStatus {
  'on-air': boolean;
}

export interface PostinoClientRecommendationList {
  /**
   * Client recommendation interval.
   * Unit is a second.
   * Client will request recommendation list again at least after ttl time.
   * @format int64
   * @example 1366338021
   */
  ttl: number;
  items: PostinoRecommendation[];
}

export interface PostinoClientRecommendationInternalList {
  /**
   * Client recommendation interval.
   * Unit is a second.
   * Client will request recommendation list again at least after ttl time.
   * @format int64
   * @example 1366338021
   */
  ttl: number;
  items: PostinoRecommendationInternal[];
}

export interface PostinoPaginatedPresetResponse {
  /**
   * The ID of the location in which the preset was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId?: string;
  items?: PostinoPresetRoutine[];
  _links?: Links;
}

export interface PostinoPresetRoutine {
  /**
   * Unique identifier of the routine template
   * @example "431e28ca-c33b-49c9-a5a1-dce40e41f8a4"
   */
  routineTemplateId: string;
  /**
   * Translated text for preset(Based on Accept-Language Header)
   * @example "Notify when someone arrive"
   */
  presetTitle: string;
  /**
   * version of rule
   * @example "1.0.0"
   */
  ruleVersion: string;
  /** Recommended routine body template(from rabbit) */
  routineTemplate: RuleRequest;
}

/** Translatable template texts for preset routine. */
export interface TranslationTextRoutineTemplate {
  /** @example "EN US preset text" */
  presetText: string;
}

/** @example {"en-US":{"presetText":"EN US preset text"},"fr-FR":{"presetText":"FR FR preset text"}} */
export type TranslationsRoutineTemplate = Record<string, TranslationTextRoutineTemplate>;

export interface PiperLogsRequest {
  /**
   * UTC timestamp in milliseconds when the log is sent.
   * @format int64
   * @example 1598304586643
   */
  sentAt: number;
  /** @example "Dalvik/2.1.0 (Linux; U; Android 5.0.2; SM-G901F Build/LRX22G)" */
  userAgent: string;
  /** @example "en-GB" */
  locale?: string;
  /** @example "Asia/Singapore" */
  timezone?: string;
  /** @example "HK|SG" */
  region?: string;
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6c087082-feb9-4687-9f1c-4fab435b6d9b"
   */
  userUuid?: string;
  device?: {
    /** @example "samsung" */
    manufacturer?: string;
    /** @example "SM-G901F" */
    model?: string;
    /** Client device type. */
    type?: ClientDeviceType;
  };
  network?: {
    /** @example "wifi | mobile" */
    connection?: string;
    /** @example "Verizon" */
    carrier?: string;
    /**
     * Combination of Mobile Country Codes (MCC) and Mobile Network Codes (MNC)
     * @example "28988"
     */
    mccMnc?: string;
  };
  /** An array of client logs */
  logs?: ClientLog[];
}

export interface ClientLog {
  /**
   * UTC timestamp in milliseconds for the log.
   * @format int64
   * @example 1598304586643
   */
  timestamp: number;
  /** @example "component.class | microservice name" */
  logger?: string;
  /**
   * unqiue id for the given log
   * @example "412386fb-74b9-46d1-824c-07f4f99b0c95"
   */
  correlationId?: string;
  /**
   * log level
   * @example "ERROR"
   */
  level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'TRACE';
  /** user readable message */
  message: string;
  /** log details, no more than 32kb */
  details?: string;
  tags?: string[];
  metadata?: Record<string, string>;
}

export interface PiperClicksRequest {
  /**
   * UTC timestamp in milliseconds when the log is sent.
   * @format int64
   * @example 1598304586643
   */
  sentAt: number;
  /** @example "Dalvik/2.1.0 (Linux; U; Android 5.0.2; SM-G901F Build/LRX22G)" */
  userAgent: string;
  /**
   * Samsung account guid
   * @example "xf6slriszg"
   */
  saGuid?: string;
  /** @example "en-GB" */
  locale?: string;
  /** @example "Asia/Singapore" */
  timezone?: string;
  /** @example "HK|SG" */
  region?: string;
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6c087082-feb9-4687-9f1c-4fab435b6d9b"
   */
  userUuid?: string;
  device?: {
    /**
     * ST device UUID
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "201e246f-3a88-4ede-b6a8-ef4df423c7fb"
     */
    deviceId?: string;
    /** @example "samsung" */
    manufacturer?: string;
    /** @example "SM-G901F" */
    model?: string;
    /** Client device type. */
    type?: ClientDeviceType;
  };
  network?: {
    /** @example "wifi | mobile" */
    connection?: string;
    /** @example "Verizon" */
    carrier?: string;
    /**
     * Combination of Mobile Country Codes (MCC) and Mobile Network Codes (MNC)
     * @example "28988"
     */
    mccMnc?: string;
  };
  /** An array of client screen data */
  screen?: ClientScreen[];
}

export interface ClientScreen {
  /** @example "RECOMMEDATION" */
  category:
    | 'ANDROID_AUTO'
    | 'AUTOMATION'
    | 'DASHBOARD'
    | 'DEVICES'
    | 'HISTORY'
    | 'HOW_TO_USE'
    | 'LOCATION'
    | 'MEMBER'
    | 'MENU'
    | 'NOTICES'
    | 'PUSH_RECOMMENDATION'
    | 'RECIPE'
    | 'RECOMMENDATION'
    | 'ROOMS'
    | 'SCENE'
    | 'SERVICE_PLUGIN'
    | 'SETTINGS'
    | 'SMART_APP'
    | 'SMARTTHINGS_APP'
    | 'SMARTTHINGS_COMPANION_SDK'
    | 'SMARTTHINGS_EXTERNAL'
    | 'SMARTTHINGS_KIT'
    | 'SMARTTHINGS_QUICKPANEL'
    | 'SMARTTHINGS_WIDGET'
    | 'SMARTTHINGS_PLUGIN_DEVICE'
    | 'SMARTTHINGS_PLUGIN_SERVICE'
    | 'MEDIA_CONTINUITY'
    | 'NDS_APP'
    | 'MUSIC_SYNC'
    | 'TV_SMARTTHINGS_APP';
  /** @example "Add Devices" */
  screenName?: string;
  /**
   * start time of the screen in milliseconds
   * @format int64
   * @example 1598304586643
   */
  startTime?: number;
  /**
   * end time of the screen in milliseconds
   * @format int64
   * @example 1598304586900
   */
  endTime?: number;
  /** An array of client click event */
  clicks?: ClientScreenClick[];
}

export interface ClientScreenClick {
  /**
   * timestamp of the click event in milliseconds
   * @format int64
   * @example 1571874833000
   */
  timestamp: number;
  /** text or toggle that is selected or clicked on */
  label?: string;
  /**
   * Click action types.
   * RECOMMENDATION_DELIVER are not used by client, but internal to the cloud.
   * @example "RECOMMENDATION_CLICK"
   */
  action:
    | 'ADD'
    | 'AUDIO_PATH'
    | 'BACK'
    | 'CANCEL'
    | 'CHANGE_VALUE'
    | 'CLOSE'
    | 'CONTENT_SHARING_REQUEST'
    | 'DELETE'
    | 'DEVICE'
    | 'DEVICE_CONFIGURATION'
    | 'DEVICE_CONTROL'
    | 'DEVICE_GROUP_CONTROL'
    | 'DEVICE_SETTING'
    | 'DISPLAY_ITEM_CONFIGURATION'
    | 'EDIT'
    | 'EXECUTE_CONFIGURATION'
    | 'ITEM_CLICK'
    | 'LAUNCH'
    | 'LOCATION_CONFIGURATION'
    | 'MANAGE'
    | 'NOTIFICATION'
    | 'NOTIFICATION_CLICK'
    | 'NOTIFICATION_DISMISS'
    | 'ONBOARDING'
    | 'OPEN'
    | 'PLUGIN_LAUNCH_REQUEST'
    | 'PP_AGREEMENT'
    | 'PUSH_RECOMMENDATION_CLICK'
    | 'PUSH_RECOMMENDATION_DELIVER'
    | 'PUSH_RECOMMENDATION_DISMISS'
    | 'PUSH_RECOMMENDATION_IMPRESSION'
    | 'PUSH_RECOMMENDATION_NO_ACTION'
    | 'RECEIVE_NOTIFICATION'
    | 'RECOMMENDATION_CLICK'
    | 'RECOMMENDATION_DELIVER'
    | 'RECOMMENDATION_DISMISS'
    | 'RECOMMENDATION_IMPRESSION'
    | 'RECOMMENDATION_NO_ACTION'
    | 'SAVE'
    | 'SCENE'
    | 'SCENE_EXECUTION'
    | 'SCENE_NOTIFICATION_CONFIGURATION'
    | 'SIGN_IN'
    | 'TOGGLE_OFF'
    | 'TOGGLE_ON'
    | 'TURN_OFF'
    | 'TURN_ON'
    | 'WIDGET_SCENE'
    | 'INSTALL'
    | 'PLAY'
    | 'STOP'
    | 'EASYPAIR'
    | 'DISCOVERY_POPUP'
    | 'REAL_SYNC'
    | 'ONBOARDING_DONE'
    | 'SYNC_START'
    | 'SYNC_STOP'
    | 'ENTRY_POINT'
    | 'INSTALL_EPA'
    | 'LAUNCH_EPA'
    | 'RECOMMENDATION'
    | 'PRESET'
    | 'DEVICE_VIEW'
    | 'LAUNCH_SCREEN'
    | 'MATTER_SHARE';
  /** @example {"recommendationId":"82260271-0b07-49af-85a8-a7b553981543","locationId":"82260271-0b07-49af-85a8-a7b553981543","campaignId":"76660271-0b07-49af-85a8-a7b553981546"} */
  metadata?: Record<string, string>;
}

export interface PiperHubLogsResponse {
  /**
   * unique log ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4d54a250-ec78-4858-8d28-2ca447ef28a4"
   */
  id: string;
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
  /**
   * ST device UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "201e246f-3a88-4ede-b6a8-ef4df423c7fb"
   */
  deviceId?: string;
  /**
   * ST location UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "354ebd06-318d-4b29-909a-91bf5b8b5604"
   */
  locationId?: string;
  /**
   * error code
   * @example "33-506-CLD-404"
   */
  errorCode?: string;
  /**
   * region identifier
   * @maxLength 100
   */
  region?: string;
  /**
   * identifer for deployment environment
   * @maxLength 100
   */
  environment?: string;
  /**
   * pre-signed URL for uploading logs to S3
   * @format uri
   */
  fileUrl: string;
}

export interface PiperDeviceLogsResponse {
  /**
   * unique log ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4d54a250-ec78-4858-8d28-2ca447ef28a4"
   */
  id: string;
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
  /**
   * ST device UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "201e246f-3a88-4ede-b6a8-ef4df423c7fb"
   */
  deviceId?: string;
  /**
   * ST location UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "354ebd06-318d-4b29-909a-91bf5b8b5604"
   */
  locationId?: string;
  /**
   * error code
   * @example "33-506-CLD-404"
   */
  errorCode?: string;
  /**
   * region identifier
   * @maxLength 100
   */
  region?: string;
  /**
   * identifer for deployment environment
   * @maxLength 100
   */
  environment?: string;
  /**
   * pre-signed URL for uploading logs to S3
   * @format uri
   */
  fileUrl: string;
}

export interface PagedPiperGetLogsResponse {
  /**
   * Max number of logs in a page
   * @example 25
   */
  pageSize?: number;
  /**
   * Total number of logs
   * @example 145
   */
  totalCount?: number;
  logs?: PiperGetLogResponse[];
}

export interface PiperGetLogResponse {
  /**
   * Unique log Id
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4bc484fd-50d3-482b-9d95-29d5f6100fe8"
   */
  id: string;
  /**
   * Unix timestamp in milliseconds when the log is sent
   * @format int64
   * @example 1571960607143
   */
  sentAt: number;
  /** Piper log type. */
  logType: PiperLogType;
  /**
   * ST device UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "201e246f-3a88-4ede-b6a8-ef4df423c7fb"
   */
  deviceId?: string;
  /**
   * ST location UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "354ebd06-318d-4b29-909a-91bf5b8b5604"
   */
  locationId?: string;
  /**
   * error code
   * @example "33-506-CLD-404"
   */
  errorCode?: string;
  /**
   * Unix timestamp in milliseconds when the error occurred.
   * @format int64
   * @example 1560960607143
   */
  errorTime?: number;
  /**
   * catalog app UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4924f2a5-8538-4b04-86e6-710a21fb71a6"
   */
  catalogAppUuid?: string;
  /**
   * catalog app UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "1321eb45-34e5-4dc1-8637-fcb876118616"
   */
  catalogDeviceUuid?: string;
  /**
   * catalog app endpoint
   * @example "Global_PRD"
   */
  catalogEndPoint?: string;
  /**
   * pre-signed URL for uploading logs to S3
   * @format uri
   */
  fileUrl: string;
}

export interface PiperGdprRequest {
  /**
   * SA Guid.
   * @example "xf6slriszg"
   */
  saguid: string;
  /** Unique Id corresponding to the request on GDPR API Server. */
  gdpr_id: string;
  /** The title in the request body. */
  title: PiperGdprTitle;
  /**
   * URL to send callback to.
   * @example "https://sampleCallbackurl.samsung.com/gdpr"
   */
  callback_url?: string;
  /** GDPR S3 base path to upload the generated file. Only required in Access API. */
  file_path?: string;
  /** File name that has to be uploaded. Only required in Access API. */
  file_name?: string;
  /** GDPR bucket_name to upload to data to. Only required in Access API. */
  bucket_name?: string;
  /** S3 region where the bucket exists. Only required in Access API. */
  region?: string;
}

export interface PiperGdprCallback {
  /** Unique Id corresponding to the request on GDPR API Server. */
  gdpr_id: string;
  /**
   * success or failed.
   * @example "success"
   */
  status: string;
  /** Optional, error message in case of failure. */
  error?: string;
  /** Optional, send only if the service is uploading to it's own bucket. */
  fileUrl?: string;
  /** Set to true when no User Pii data is available with the service, empty file should not be uploaded to S3 bucket. */
  noData?: boolean;
}

/** The title in the request body. */
export enum PiperGdprTitle {
  RightToAccess = 'Right to access',
  RightToErasure = 'Right to erasure',
  RightToRestrict = 'Right to restrict',
  RightToPortability = 'Right to portability',
}

export interface PiperDeviceLogsRequest {
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
  /**
   * ST device UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4e4bb5c9-37de-4c6d-846b-ae70493d2ee0"
   */
  deviceId?: string;
  /**
   * ST location UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8a3ac31b-dfa1-4a31-87d9-91de41fad714"
   */
  locationId?: string;
  /**
   * error code
   * @example "33-506-CLD-404"
   */
  errorCode?: string;
}

export interface PiperHubLogsRequest {
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
  /**
   * ST device UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4e4bb5c9-37de-4c6d-846b-ae70493d2ee0"
   */
  deviceId?: string;
  /**
   * ST location UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8a3ac31b-dfa1-4a31-87d9-91de41fad714"
   */
  locationId?: string;
  /**
   * error code
   * @example "33-506-CLD-404"
   */
  errorCode?: string;
}

/** Piper log type. */
export enum PiperLogType {
  EASYSETUP = 'EASYSETUP',
  HUB = 'HUB',
  DEVICE = 'DEVICE',
  CONNECTION = 'CONNECTION',
  AUTORECONNECTION = 'AUTORECONNECTION',
}

/** Client device type. */
export enum ClientDeviceType {
  PHONE = 'PHONE',
  TABLET = 'TABLET',
  WATCH = 'WATCH',
  FAMILY_HUB = 'FAMILY_HUB',
  PC = 'PC',
  TV = 'TV',
}

export interface CreateMobileChildrenRequest {
  /**
   * @maxItems 10
   * @minItems 1
   */
  children?: CreateMobileChild[];
}

export interface CreateMobileChild {
  locationId: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  /**
   * @maxItems 10
   * @minItems 1
   */
  components: Component[];
  /**
   * used for UI metadata
   * @maxLength 50
   */
  vid: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  mnmn: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  ocfDeviceType?: string;
}

export interface UpdateMobileChild {
  /**
   * @maxItems 10
   * @minItems 1
   */
  components?: Component[];
  /**
   * used for UI metadata
   * @maxLength 50
   */
  vid?: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  mnmn?: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  ocfDeviceType?: string;
}

export interface MobileChild {
  deviceId: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  locationId: string;
  /**
   * the owner's SmartThings user id of parent mobile device
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId: string;
  /**
   * @maxItems 10
   * @minItems 1
   */
  components: Component[];
  /**
   * used for UI metadata
   * @maxLength 50
   */
  vid: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  mnmn: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  ocfDeviceType?: string;
}

export interface MigratedMobileChild {
  deviceId: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  locationId: string;
  /**
   * the owner's SmartThings user id of parent mobile device
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId: string;
  /**
   * @maxItems 10
   * @minItems 1
   */
  components: Component[];
  /**
   * used for UI metadata
   * @maxLength 50
   */
  vid?: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  mnmn?: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  ocfDeviceType?: string;
}

export interface CapabilityEvents {
  /**
   * the set of capability events to update
   * @maxItems 10
   * @minItems 1
   */
  events: CapabilityEvent[];
}

export interface CapabilityEventsResponse {
  /** the set of capability events to update */
  events?: CapabilityEventResponse[];
}

export interface CapabilityEventResponse {
  id?: string;
  stateChange?: boolean;
}

/** the event of a capability in MAT. Follow the same format of Gizmo deviceEvents */
export interface CapabilityEvent {
  /**
   * Capability that this event relates to.
   * @example "geofence"
   */
  capability: string;
  /**
   * The name of the component on this device, default is 'main'.
   * @example "main"
   */
  component: string;
  /**
   * Name of the capability attribute that this event relates to.
   * @example "state"
   */
  attribute: string;
  /** Value associated with the event. The valid value depends on the capability. */
  value: object;
  /**
   * Key value pairs about the state of the device. Valid values depend on the capability.
   * If the capability does not define a data element this should be null or not included.
   */
  data?: Record<string, object>;
  /** The unit of the value if applicable for the capability or else it should be null or not included. */
  unit?: string;
  /** The id on the command that trigged this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

/** The details of Mobile Device */
export interface MobileDevice {
  /**
   * Id of the mobile assigned by Mobile Backend.
   * @example "244d9196-fc90-4122-9fe8-2343eede60c2"
   */
  deviceId: string;
  /**
   * A unique id that is platform dependant used to identify the device.
   * @maxLength 50
   * @example "9774d56d682e549c"
   */
  mobileUniqueId: string;
  mobileType: MobileType;
  platform: Platform;
  /**
   * @maxLength 50
   * @example "10.4-abc.567"
   */
  os?: string;
  /**
   * @maxLength 50
   * @example "SM-N971N"
   */
  modelNumber?: string;
  /**
   * @maxLength 50
   * @example "R3CM601LAGV"
   */
  serialNumber?: string;
  /**
   * the default name (device alias) of MAT
   * @maxLength 50
   * @example "Galaxy Note 10 5G"
   */
  name: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  /**
   * the owner's SmartThings user id
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId: string;
  pushType?: PushType;
  /**
   * Push registration token assigned by GCM, FCM, SPP, APNS
   * @maxLength 100
   * @example "AnLVPk:APA91bHUlPNOQaj-kXU2PwJQwOcLux3wXV2d1xcEvMQl2uWT"
   */
  pushRegId?: string;
  /**
   * @maxItems 10
   * @minItems 1
   */
  components: Component[];
  children: MigratedMobileChild[];
  /**
   * used for UI metadata
   * @maxLength 50
   */
  vid: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  mnmn: string;
}

export enum Platform {
  Apple = 'apple',
  Android = 'android',
  Tizen = 'tizen',
}

/** The details of Mobile Device */
export interface UpdateMobileRequest {
  /**
   * @maxLength 50
   * @example "10.4-abc.567"
   */
  os?: string;
  /**
   * the default name (device alias) of MAT
   * @maxLength 50
   * @example "Galaxy Note 10 5G"
   */
  name: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  /**
   * @maxLength 50
   * @example "SM-N971N"
   */
  modelNumber?: string;
  /**
   * @maxLength 50
   * @example "R3CM601LAGV"
   */
  serialNumber?: string;
  /**
   * A unique id that is platform dependant used to identify the device.
   * @maxLength 50
   * @example "9774d56d682e549c"
   */
  mobileUniqueId?: string;
  mobileType?: MobileType;
  platform?: Platform;
  pushType?: PushType;
  /**
   * Push registration token assigned by GCM, FCM, SPP, APNS
   * @maxLength 100
   * @example "AnLVPk:APA91bHUlPNOQaj-kXU2PwJQwOcLux3wXV2d1xcEvMQl2uWT"
   */
  pushRegId?: string;
  /**
   * @maxItems 10
   * @minItems 1
   */
  components: Component[];
  /**
   * used for UI metadata
   * @maxLength 50
   */
  vid: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  mnmn: string;
}

/** Request to create a Mobile Device */
export interface CreateMobileRequest {
  /**
   * A unique id that is platform dependant used to identify the device.
   * @example "9774d56d682e549c"
   */
  mobileUniqueId: string;
  mobileType: MobileType;
  /** @example "SM-N971N" */
  modelNumber?: string;
  /** @example "R3CM601LAGV" */
  serialNumber?: string;
  platform: Platform;
  /**
   * @maxLength 50
   * @example "10.4-abc.567"
   */
  os?: string;
  /**
   * the default name (device alias) of Mobile Device
   * @example "Galaxy Note 10 5G"
   */
  name: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  pushType?: PushType;
  /**
   * Push registration token assigned by GCM, FCM, SPP, APNS
   * @example "AnLVPk:APA91bHUlPNOQaj-kXU2PwJQwOcLux3wXV2d1xcEvMQl2uWT"
   */
  pushRegId?: string;
  /** @minItems 1 */
  components: Component[];
  /**
   * A list of already existing presence devices that should be associated as children.
   * This is used to migrate existing DTH presence devices.
   * @maxItems 10
   */
  children?: string[];
  /**
   * used for UI metadata
   * @maxLength 50
   */
  vid: string;
  /**
   * used for UI metadata
   * @maxLength 50
   */
  mnmn: string;
}

/** @example "fcm" */
export enum PushType {
  Fcm = 'fcm',
  Gcm = 'gcm',
  Apns = 'apns',
  Spp = 'spp',
}

/** @example "phone" */
export enum MobileType {
  Phone = 'phone',
  Watch = 'watch',
  Tablet = 'tablet',
}

/** Components in the mobile */
export interface Component {
  /** @example "main" */
  id: string;
  /** @example "string" */
  label?: string;
  /**
   * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories).
   * @maxItems 1
   * @minItems 1
   */
  categories?: string[];
  /**
   * @maxItems 20
   * @minItems 1
   */
  capabilities: CapabilityRef[];
}

/** Capability representing device status */
export interface CapabilityRef {
  /**
   * Capability Id
   * @example "presenceSensor"
   */
  id: string;
  /**
   * the version of the capability
   * @default 1
   */
  version?: number;
}

export interface MobileChildren {
  items: MobileChild[];
}

export interface PagedMobileDevices {
  items: MobileDevice[];
}

export interface MobileCommandRequest {
  /** An array of commands to execute on the Device. */
  commands?: {
    /**
     * A UUID used for tracking the individual command.
     * This should be returned in the command response to correlate status of each command.
     * @format uuid
     */
    id: string;
    /**
     * The name of the component on this device, default is 'main'. The component must be valid for the device.
     * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
     * @default "main"
     */
    component: string;
    /** Capability that this command relates to. This must be a capability of the component. */
    capability: string;
    /** Name of the command, this must be valid for the capability. */
    command: string;
    /**
     * Arguments of the command.
     * All the required arguments defined in the capability's command argument definition must be provided.
     * The type of the arguments are dependent on the type of the capability's command argument.
     * Please refer to the capabilities definition at https://smartthings.developer.samsung.com/develop/api-ref/capabilities.html
     */
    arguments?: object[];
  }[];
}

export interface DeviceCommandsResponse {
  results?: CommandResult[];
}

export interface CommandResult {
  /**
   * A UUID used for tracking the individual command.
   * @format uuid
   */
  id?: string;
  /**
   * `ACCEPTED`: the command is processing but it's outcome is unknown
   * `COMPLETED`: the command has successfully completed
   * `FAILED`: the command has failed
   */
  status?: CommandStatus;
}

/**
 * `ACCEPTED`: the command is processing but it's outcome is unknown
 * `COMPLETED`: the command has successfully completed
 * `FAILED`: the command has failed
 */
export enum CommandStatus {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface PiperHistoryRequest {
  /**
   * UTC timestamp in milliseconds when the log is sent.
   * @format int64
   * @example 1598304586643
   */
  sentAt: number;
  /** @example "Dalvik/2.1.0 (Linux; U; Android 5.0.2; SM-G901F Build/LRX22G)" */
  userAgent: string;
  /**
   * Samsung account guid
   * @example "xf6slriszg"
   */
  saGuid?: string;
  /**
   * User language code (language set on the device) Format :{language_code}-{country_code} Example : en-GB, ko-KR, en-US, pt-PT Language code : ISO 639-1 language code-ISO Country code : ISO 3166 alpha-2 country Code
   * @example "en-GB"
   */
  locale?: string;
  /**
   * Requested timezone. It follows TZ database time zones name. Example: Asia/Singapore, America/Los_Angeles
   * @example "Asia/Singapore"
   */
  timezone?: string;
  /**
   * Region code that the user belongs to. Example: HK, SG
   * @example "HK|SG"
   */
  region?: string;
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6c087082-feb9-4687-9f1c-4fab435b6d9b"
   */
  userUuid?: string;
  device?: {
    /**
     * ST device UUID
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "201e246f-3a88-4ede-b6a8-ef4df423c7fb"
     */
    deviceId?: string;
    /** @example "samsung" */
    manufacturer?: string;
    /** @example "SM-G901F" */
    model?: string;
    /** Client device type. */
    type?: ClientDeviceType;
  };
  network?: {
    /** @example "wifi | mobile" */
    connection?: string;
    /** @example "Verizon" */
    carrier?: string;
    /**
     * Combination of Mobile Country Codes (MCC) and Mobile Network Codes (MNC)
     * @example "28988"
     */
    mccMnc?: string;
  };
  /** An array of client screen data */
  screen?: ClientScreen[];
}

export interface PiperActivitiesRequest {
  /**
   * UTC timestamp in milliseconds when the log is sent.
   * @format int64
   * @example 1598304586643
   */
  sentAt: number;
  /** @example "Dalvik/2.1.0 (Linux; U; Android 5.0.2; SM-G901F Build/LRX22G)" */
  userAgent: string;
  /**
   * Samsung account guid
   * @example "xf6slriszg"
   */
  saGuid?: string;
  /**
   * User language code (language set on the device) Format :{language_code}-{country_code} Example : en-GB, ko-KR, en-US, pt-PT Language code : ISO 639-1 language code-ISO Country code : ISO 3166 alpha-2 country Code
   * @example "en-GB"
   */
  locale?: string;
  /**
   * Requested timezone. It follows TZ database time zones name. Example: Asia/Singapore, America/Los_Angeles
   * @example "Asia/Singapore"
   */
  timezone?: string;
  /**
   * Region code that the user belongs to. Example: HK, SG
   * @example "HK|SG"
   */
  region?: string;
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6c087082-feb9-4687-9f1c-4fab435b6d9b"
   */
  userUuid?: string;
  device?: {
    /**
     * ST device UUID
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "201e246f-3a88-4ede-b6a8-ef4df423c7fb"
     */
    deviceId?: string;
    /** @example "samsung" */
    manufacturer?: string;
    /** @example "SM-G901F" */
    model?: string;
    /** Client device type. */
    type?: ClientDeviceType;
  };
  network?: {
    /** @example "wifi | mobile" */
    connection?: string;
    /** @example "Verizon" */
    carrier?: string;
    /**
     * Combination of Mobile Country Codes (MCC) and Mobile Network Codes (MNC)
     * @example "28988"
     */
    mccMnc?: string;
  };
  /** An array of client screen data */
  screen?: ClientScreen[];
}

export interface DeviceHealthResponse {
  /** Id of the device */
  deviceId?: string;
  /** Current state of the device */
  state?: 'ONLINE' | 'OFFLINE';
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
  /** id of the location the device is in. Will be null for user level devices */
  locationId?: string;
}

export interface FlatDeviceStatusPagedResult {
  items?: FlatDeviceStatus[];
  _links?: Links;
}

export interface FlatDeviceStatus {
  /**
   * The identifier for the device instance.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The identifier for the device
   * @example "main"
   */
  componentId: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface FlatDeviceGroupStatusPagedResult {
  items?: FlatDeviceGroupStatus[];
  _links?: Links;
}

export interface FlatDeviceGroupStatus {
  /**
   * The identifier for the device group.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceGroupId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface WeatherData {
  /**
   * The location id of the weather data
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * Time the data was pulled from the content provider.
   * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
   */
  lastUpdatedTime?: string;
  /**
   * An ISO Alpha-3 country code. (i.e. USA, CAN)
   * @format ^[A-Z]{3}$
   */
  countryCode?: string;
  /** Describes the time of day */
  timeOfDay?: 'DAY' | 'NIGHT' | 'UNKNOWN';
  /** Weather vendor info */
  vendorInfo?: {
    /** Name of the vendor */
    name: string;
    /** A detail URL from the weather vendor with a detailed weather information web page */
    url?: string;
  };
  /** Weather info */
  weather?: {
    /** Description of the weather */
    description?: string;
    /** Weather icon url */
    icon?: string;
    /**
     * (This attribute is not available in Korea and Japan)
     * Descriptive sky cover - based on percentage of cloud cover.
     *
     * Range - Clear: coverage < 0.09375; Partly Cloudy: coverage < .59375; Mostly Cloudy: coverage < .75; Cloudy: coverage >= .75
     */
    cloudCoverPhrase?: string;
    /** The temperature of the location */
    temperature?: {
      /**
       * Temperature value
       * @example -5
       */
      value: number;
      /**
       * Temperature unit
       * @example "C"
       */
      unit: string;
    };
  };
  /** The Air Quality of the location - Korea only */
  airQuality?: {
    /** Amount of PM10 in the air */
    pm10Amount?: {
      /**
       * PM10 value
       * @example 8.26
       */
      value: number;
      /**
       * PM10 unit
       * @example "μg/m^3"
       */
      unit: string;
    };
    /** index of particulate matter less than 10 microns */
    pm10Index?: number;
    /** Amount of PM25 in the air */
    pm25Amount?: {
      /**
       * PM25 value
       * @example 16.94
       */
      value: number;
      /**
       * PM25 unit
       * @example "μg/m^3"
       */
      unit: string;
    };
    /** index of particulate matter less than 2.5 microns */
    pm25Index?: number;
    /** Air index */
    index?: {
      /**
       * Index value
       * @example 41
       */
      value: number;
      /**
       * Index unit
       * @example "CAQI"
       */
      unit: string;
    };
  };
}

export interface IncidentPostBody {
  /** The location ID the app was set to on the mobile device at the time of the incident. */
  locationId?: string;
  /**
   * Country code that is used for the catalog service. If no country is provided, server will
   * default to US
   */
  country?: string;
  /**
   * Language code that is used for the catalog service. If no language is provided, server will
   * default to en-US
   */
  language?: string;
  /**
   * JSON blob that will contain all the configuration settings of the mobile devices. Data provided in this field
   * will be posted on the JIRA ticket when created. Must be a valid JSON.
   */
  additionalData?: object;
}

export interface IncidentIdResponse {
  /**
   * ID of the incident
   * @format uuid
   */
  incidentId?: string;
}

/** @example {"skill":{"stage":"your skill stage","id":"your skill id"},"user":{"id":"User ID"},"accountLink":{"status":"LINKED"},"status":"ENABLED"} */
export interface LinkSuccessResponse {
  skill: {
    stage: string;
    id: string;
  };
  user: {
    id: string;
  };
  accountLink: {
    status: string;
  };
  status: string;
}

/** @example {"requestId":"0fdac3212ee37546","error":{"code":"XXX","message":"The Alexa API returned a XXX response, check the logs to see the response body","target":null,"details":[]}} */
export interface LinkErrorResponse {
  requestId: string;
  error: {
    code: string;
    message: string;
    target?: string;
    details?: object[];
  };
}

export interface WrappedMainSwatchItem {
  /** The type of object: `BASIC`, `CAMERA`, `CLOUD`, `COMPLEX`, `COMPLEX_CLOUD`, `BASIC_PLUS` */
  type: MainSwatchType;
}

export interface WrappedDetailSwatchItem {
  /** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
  type: DetailSwatchType;
}

/** The type of object: `BASIC`, `CAMERA`, `CLOUD`, `COMPLEX`, `COMPLEX_CLOUD`, `BASIC_PLUS` */
export enum MainSwatchType {
  BASIC = 'BASIC',
  CAMERA = 'CAMERA',
  CLOUD = 'CLOUD',
  COMPLEX = 'COMPLEX',
  COMPLEX_CLOUD = 'COMPLEX_CLOUD',
  BASIC_PLUS = 'BASIC_PLUS',
}

export type DeviceGroupSwatch = MainSwatch & {
  /**
   * Unique Id of a location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon: string;
  /** The inactive icon url. */
  inactiveIcon?: string;
  /** An array of devices in the group */
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
  /**
   * Unique Id of the device group.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceGroupId: string;
  /** This is the nullable label to be used for camera groups.  State label should be used when this is null. */
  label?: string;
  /**
   * Unique Id of a room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** The name of this device group. */
  groupName: string;
  /** The type of the device group */
  groupType: DeviceGroupType;
  states: DeviceGroupState[];
  actions: DeviceGroupAction[];
};

export interface CloudSwatchStatus {
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The id of the component. */
  componentId: string;
  /** The id of the group this status belongs to. */
  groupId?: string;
  /** The id of the capability. */
  capabilityId: string;
  /** The name of the attribute. */
  attributeName: string;
  state: CloudStatusState;
  action?: CloudStatusAction;
  groups?: CloudStatusGroup[];
}

/** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
export enum DetailSwatchType {
  BUTTON = 'BUTTON',
  COLOR = 'COLOR',
  ENUMERATED = 'ENUMERATED',
  SLIDER = 'SLIDER',
  TOGGLE = 'TOGGLE',
  VALUE = 'VALUE',
}

export interface MainSwatch {
  /**
   * Unique Id of a location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** List of component/capability id pairs that have the ephemeral flag as true. */
  ephemeral?: EphemeralData[];
  /** The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon: string;
  /** The inactive icon url. */
  inactiveIcon: string;
  /** The message to display when device is offline */
  offlineMessage: string;
  /** Information about which plugin to display for the details view. */
  plugin?: Plugin;
  /** Lottie animation data */
  lottieData?: LottieData;
}

/** The type of the device group */
export enum DeviceGroupType {
  LIGHTING = 'LIGHTING',
  GENERIC = 'GENERIC',
  UNDETERMINED = 'UNDETERMINED',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
}

export interface DeviceGroupState {
  /** The id of the capability. */
  capabilityId: string;
  /** The name of the attribute. */
  attributeName: string;
  /** The value of the attribute when this state should be used. (Always match when value is null.  When null, "*" will be used.) */
  value: string;
  /** The name of the label. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** Type of state */
  type: StateType;
  /** The icon url. The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon?: string;
  /** Used to display dynamic parts of the label based on attribute states. */
  arguments?: SwatchArgument[];
}

export interface DeviceGroupAction {
  /** The id of the capability. */
  capabilityId: string;
  /** The name of the attribute. */
  attributeName: string;
  /** The action value. */
  value: string;
  /** The icon url. The icon url. Client should set icon size, type, and theme with parameters at runtime. See `getActionIcon` API. */
  icon: string;
  /** The name of the command. */
  command: string;
}

/** A group */
export interface DeviceGroupResponse {
  /**
   * Name of the group created
   * @example "helloWorldGroup"
   */
  groupName: string;
  /** The type of the device group */
  groupType: DeviceGroupType;
  /**
   * Location where this group is
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  locationId?: string;
  /** restriction tier of the device group */
  restrictionTier?: number;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
  /**
   * a GUID that identifies a group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  deviceGroupId: string;
  /** Lowest common denominator capability of all the devices in the group */
  deviceGroupCapabilities: DeviceGroupCapability[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /** Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands. */
  summaryGroup: boolean;
}

/** A group */
export interface DeviceGroupUpdateRequest {
  /** Name of the group */
  groupName: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
}

export type DeviceGroupDeleteResponse = Record<string, any>;

/** The capability that is common to all devices in the group */
export interface DeviceGroupCapability {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

export interface CloudStatusState {
  /** The name of the label. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** Type of state */
  type: StateType;
  /** The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon?: string;
  /** The badge icon url. Client should set icon size and type with parameters at runtime. See `getBadgeIcon` API. */
  badge?: string;
}

export interface CloudStatusAction {
  /** The componentId */
  componentId: string;
  /** The capabilityId */
  capabilityId: string;
  /** The attributeName */
  attributeName: string;
  /** The name of the command. */
  command: string;
  /** The icon url. Client should set icon size, type, and theme with parameters at runtime. See `getActionIcon` API. */
  icon: string;
  /** If non-null, the argument to be sent with the command. */
  argument?: string;
}

/** Optional group(s) for COMPLEX_CLOUD statuses */
export interface CloudStatusGroup {
  /** The group name */
  name: string;
  /** The groupId */
  groupId: string;
  /** The componentId */
  componentId: string;
  /** The capabilityId */
  capabilityId: string;
  /** The attributeName */
  attributeName: string;
  state: CloudStatusState;
  action?: CloudStatusAction;
}

/** Information about which plugin to display for the details view. */
export interface Plugin {
  /** The URI for the plugin in the form `plugin://...` */
  uri?: string;
}

/** Lottie animation data */
export interface LottieData {
  /** URL of Lottie icon */
  icon: string;
  scenes: LottieScene[];
}

/** Type of state */
export enum StateType {
  Activated = 'activated',
  Inactivated = 'inactivated',
  Running = 'running',
}

export interface SwatchArgument {
  /** The name of the argument */
  name: string;
  /** The id of the capability */
  capabilityId: string;
  /** The name of the attribute */
  attributeName: string;
  formatInfo?: SwatchFormatInfo;
}

/** Lottie scene data */
export interface LottieScene {
  /** Lottie scene type */
  type: LottieSceneType;
  /** Start frame of Lottie animation */
  startFrame: number;
  /** End frame of Lottie animation */
  endFrame: number;
  /** Does the animation loop or not */
  isLooping: boolean;
}

export interface SwatchFormatInfo {
  /**
   * To specify the type of format to display this attribute value. The corresponding field must also be included. For example, if you specify "remainingTime" here, you must also include the "remainingTime" key and its object definition for formatInfo.
   * @example "remainingTime"
   */
  type: 'remainingTime' | 'time';
  remainingTime?: {
    timeFormat: SwatchTimeFormat;
    /**
     * Specify the frequency time(second) so UI client can know how often to update the remaing time.
     * @default 60
     * @example 60
     */
    frequency?: number;
  };
  time?: {
    timeFormat: SwatchTimeFormat;
  };
}

/** Lottie scene type */
export enum LottieSceneType {
  Run = 'run',
  Running = 'running',
  Connect = 'connect',
  Disconnect = 'disconnect',
  Activate = 'activate',
  Inactivate = 'inactivate',
  Stop = 'stop',
}

/**
 * @pattern hh:mm(:ss){0,1}
 * @example "hh:mm:ss"
 */
export type SwatchTimeFormat = string;

/** A basic swatch. */
export type BASIC = WrappedMainSwatchItem & {
  basic: BasicSwatch;
};

export type BasicSwatch = MainSwatch & {
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** The id of the component. */
  componentId: string;
  /** The label or name of this Device. */
  deviceName: string;
  /** Device type data */
  deviceTypeData?: DeviceTypeData;
  states: SwatchState[];
  actions?: SwatchAction[];
  /** Idle state is only populated for buttons with a "Standby" state to let clients know which state to show after a button press. */
  idleState?: IdleState;
};

/** Device type data */
export interface DeviceTypeData {
  type: DeviceType;
}

export interface SwatchState {
  /** The id of the capability. */
  capabilityId: string;
  /** The name of the attribute. */
  attributeName: string;
  /** The id of the component. */
  componentId: string;
  /** The value of the attribute when this state should be used. (Always match when value is null.  When null, "*" will be used.) */
  value: string;
  /** The name of the label. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** Type of state */
  type: StateType;
  /** The icon url. The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon?: string;
  /** The badge icon url. The icon url. Client should set icon size and type with parameters at runtime. See `getBadgeIcon` API. */
  badge?: string;
  /** Used to display dynamic parts of the label based on attribute states. */
  arguments?: SwatchArgument[];
}

export interface EphemeralData {
  /** The id of the component. */
  componentId?: string;
  /** The id of the capability. */
  capabilityId?: string;
}

export interface SwatchAction {
  /** The id of the capability. */
  capabilityId: string;
  /** The name of the attribute. */
  attributeName: string;
  /** The id of the component. */
  componentId: string;
  /** The action value. */
  value: string;
  /** The icon url. Client should set icon size, type, and theme with parameters at runtime. See `getActionIcon` API. */
  icon: string;
  /** The name of the command. */
  command: string;
  /** If non-null, the argument to be sent with the command. */
  argument?: string;
}

export interface IdleState {
  /** The name of the label. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** Type of state */
  type: StateType;
  /** The icon url. The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon?: string;
  /**
   * Idle time is in milliseconds.
   * @format int32
   */
  idleTimeMillis: number;
}

export enum DeviceType {
  BleD2D = 'bleD2D',
  NONE = 'NONE',
}

/** A camera swatch. */
export type CAMERA = WrappedMainSwatchItem & {
  camera: CameraSwatch;
};

/** A basic plus swatch. */
export type BASICPLUS = WrappedMainSwatchItem & {
  basicPlus: BasicPlusSwatch;
};

/** A cloud swatch. */
export type CLOUD = WrappedMainSwatchItem & {
  cloud: CloudSwatch;
};

/** A complex swatch. */
export type COMPLEX = WrappedMainSwatchItem & {
  complex: ComplexSwatch;
};

/** A complex cloud swatch. */
export type COMPLEXCLOUD = WrappedMainSwatchItem & {
  complexCloud: ComplexCloudSwatch;
};

export type CameraSwatch = MainSwatch & {
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** The id of the component. */
  componentId: string;
  /** The label or name of this Device. */
  deviceName: string;
  cameraImage: CameraImage;
  overlayData: SwatchOverlayData[];
  /** Device type data */
  deviceTypeData?: DeviceTypeData;
  states: SwatchState[];
  actions?: SwatchAction[];
  /** Idle state is only populated for buttons with a "Standby" state to let clients know which state to show after a button press. */
  idleState?: IdleState;
};

export type BasicPlusSwatch = MainSwatch & {
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** The id of the component. */
  componentId: string;
  /** The label or name of this Device. */
  deviceName: string;
  /** Device type data */
  deviceTypeData?: DeviceTypeData;
  states: SwatchState[];
  actions?: SwatchAction[];
  expandable: ExpandableTypeData[];
  /** Idle state is only populated for buttons with a "Standby" state to let clients know which state to show after a button press. */
  idleState?: IdleState;
};

export type CloudSwatch = MainSwatch & {
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** The id of the component. */
  componentId: string;
  /** The label or name of this Device. */
  deviceName: string;
  /** Device type data */
  deviceTypeData?: DeviceTypeData;
  capabilities?: CloudSwatchCapability[];
};

export type ComplexSwatch = MainSwatch & {
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** The id of the component. */
  componentId: string;
  /** The label or name of this Device. */
  deviceName: string;
  /** Device type data */
  deviceTypeData?: DeviceTypeData;
  states: SwatchState[];
  actions?: SwatchAction[];
  groups: SwatchGroup[];
  groupVisibleConditions?: GroupVisibleCondition[];
  /** Idle state is only populated for buttons with a "Standby" state to let clients know which state to show after a button press. */
  idleState?: IdleState;
};

export type ComplexCloudSwatch = MainSwatch & {
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** The label or name of this Device. */
  deviceName: string;
  /** Device type data */
  deviceTypeData?: DeviceTypeData;
  groups?: CloudSwatchGroup[];
  groupVisibleConditions?: GroupVisibleCondition[];
  capabilities?: CloudSwatchCapability[];
};

export interface CameraImage {
  /** The id of the component. */
  componentId?: string;
  /** The camera capability id used to retrieve the thumbnail image. */
  capabilityId?: string;
  /** The camera attribute used to retrieve the thumbnail image. */
  attributeName?: string;
  /** The key within the associated status' `value` that returns the thumbnail URL. */
  valueKeyForThumbnailUrl?: string;
}

export interface SwatchOverlayData {
  /** The id of the component */
  componentId: string;
  /** The camera capability id used to retrieve the thumbnail image. */
  capabilityId: string;
  /** The camera attribute used to retrieve the thumbnail image. */
  attributeName: string;
  /** The value of the attribute when this state should be used. */
  value: string;
  /** The url for the lottie overlay file. */
  lottieFileUrl: string;
}

/** Expandable type data */
export interface ExpandableTypeData {
  type: ExpandableType;
}

export interface CloudSwatchCapability {
  /** The id of the capability. */
  capabilityId: string;
  /** The name of the attribute. */
  attributeName: string;
  /** The id of the component. */
  componentId: string;
}

export interface SwatchGroup {
  /** The name of the group. */
  name: string;
  /** The id of the group this component belongs to. */
  groupId: string;
  /** The icon url. The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon: string;
  /** The inactive icon url. */
  inactiveIcon: string;
  /** Lottie animation data */
  lottieData?: LottieData;
  states: SwatchState[];
  actions?: SwatchAction[];
}

/**
 * If there is no groupVisibleCondition, groups are always shown.
 * If there is a groupVisibleCondition, group should only be shown if the condition is met.
 * If groupVisibleCondition exist, but no condition is met, all groups should be hidden and swatch should be displayed as BASIC
 */
export interface GroupVisibleCondition {
  groupId?: string;
  visibleConditions?: VisibleCondition[];
}

export interface CloudSwatchGroup {
  /** The name of the group. */
  name: string;
  /** The id of the group this component belongs to. */
  groupId: string;
  /** The icon url. Client should set icon size and type with parameters at runtime. See `getOneuiIcon` API. */
  icon: string;
  /** The inactive icon url. */
  inactiveIcon: string;
  /** Lottie animation data */
  lottieData?: LottieData;
  capabilities?: CloudSwatchCapability[];
}

export enum ExpandableType {
  Stepper = 'stepper',
  Feature = 'feature',
}

export interface VisibleCondition {
  capability?: string;
  component?: string;
  attributeName?: string;
  value?: string;
  operator?:
    | 'CONTAINS'
    | 'DOES_NOT_CONTAIN'
    | 'EQUALS'
    | 'DOES_NOT_EQUAL'
    | 'GREATER_THAN'
    | 'GREATER_THAN_OR_EQUALS'
    | 'LESS_THAN'
    | 'LESS_THAN_OR_EQUALS'
    | 'ONE_OF';
}

/** A stateless control with a command. */
export type BUTTON = WrappedDetailSwatchItem & {
  /** A stateless control with a command. */
  button: ButtonSwatch;
};

/** A control representing a color picker. */
export type COLOR = WrappedDetailSwatchItem & {
  /** A control representing a color picker. */
  color: ColorSwatch;
};

/** An enum control. */
export type ENUMERATED = WrappedDetailSwatchItem & {
  /** An enum control. */
  enumerated: EnumeratedSwatch;
};

/** A slider control. */
export type SLIDER = WrappedDetailSwatchItem & {
  /** A slider control. */
  slider: SliderSwatch;
};

/** A toggle control. */
export type TOGGLE = WrappedDetailSwatchItem & {
  /** A toggle control. */
  toggle: ToggleSwatch;
};

/** A control with a value that doesn't have a command. */
export type VALUE = WrappedDetailSwatchItem & {
  /** A control with a value that doesn't have a command. */
  value: ValueSwatch;
};

/** A stateless control with a command. */
export type ButtonSwatch = DetailSwatch & {
  /** The command to call when the button is pushed. */
  command: string;
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A control representing a color picker. */
export type ColorSwatch = DetailSwatch & {
  /** The method to call to set the color after user interaction. */
  command: string;
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A list of arguments to be included in the request to set the color. */
  arguments: ColorSwatchArgument[];
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** An enum control. */
export type EnumeratedSwatch = DetailSwatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A list of possible states this Swatch can be in. */
  possibleStates?: EnumeratedSwatchPossibleState[];
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A slider control. */
export type SliderSwatch = DetailSwatch & {
  /** The minimum value allowed. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  min: object;
  /** The maximum value allowed. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  max: object;
  /** The Command to call to set the value after user interaction. */
  command: string;
  /**
   * The Attribute represented by this Swatch.
   * @example "level"
   */
  attributeName: string;
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status. */
  unit: string;
  /** The number to be added or subtracted to the current setting when incrementing or decrementing the value. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  step: object;
  /** The type of data this slider represents. */
  type: 'NUMBER' | 'INTEGER';
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A toggle control. */
export type ToggleSwatch = DetailSwatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** Data specific to the on or off state of a toggle control. */
  onState: ToggleState;
  /** Data specific to the on or off state of a toggle control. */
  offState: ToggleState;
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A control with a value that doesn't have a command. */
export type ValueSwatch = DetailSwatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status. */
  unit?: string;
  /** The type of data this control represents. */
  type: 'NUMBER' | 'INTEGER' | 'STRING';
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
  /** A list of possible states this Swatch could be in. */
  possibleStates?: ValueSwatchPossibleState[];
};

export interface DetailSwatch {
  /**
   * Unique Id of a swatch.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  swatchId: string;
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * Unique Id of a location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The Id of the Component represented by this Swatch.
   * @example "main"
   */
  componentId: string;
  /**
   * The Id of the Capability represented by this Swatch.
   * @example "switchLevel"
   */
  capabilityId: string;
  /** The label to display to the user. */
  label: string;
  /**
   * A url that points to the Swatch Icon.
   * @format uri
   * @example "https://client.smartthings.com/icons/capabilities/switchLevel/level"
   */
  icon: string;
}

/** An object describing the argument to be sent when setting the color. */
export interface ColorSwatchArgument {
  /** The name of the argument which coincides with a capability attribute value. */
  name?: string;
  /** The type of value the argument should be. */
  type?: 'number';
  /** The minimum value allowed. */
  min?: number;
  /** The maximum value allowed. */
  max?: number;
  /** Whether or not this argument is required when calling the setter. */
  required?: boolean;
}

export interface EnumeratedSwatchPossibleState {
  /** The device status value this state represents. This is the state to be displayed when the device status value matches. */
  status: string;
  /** The label to display to the user. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** The command to call when the user interacts with this state. */
  command: string;
  /** An icon url for this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** Data specific to the on or off state of a toggle control. */
export interface ToggleState {
  /** The Command to call when the toggle is flipped to this state. */
  command: string;
  /** The value of the Device status that indicates whether the toggle is in this state. */
  status: string;
  /** The label to display when the the device is in this state. */
  label: string;
  /** A url to the icon that represents the toggle when it is in this state. Overrides the icon on the control if present. */
  icon?: string;
}

export interface ValueSwatchPossibleState {
  /** The device status value this state represents. This is the state to be displayed when the device status value matches. */
  status: string;
  /** The label to display to the user. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** An icon url for this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** Device type bleD2D. */
export type DeviceTypeBleD2D = DeviceTypeData & {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl: string;
  metadata?: object;
  /** Ble profile id */
  profileId: string;
};

/** Device type NONE.  Used as a default. */
export type DeviceTypeNone = DeviceTypeData;

export interface LocationUsersResponse {
  owner?: LocationUser;
  members?: LocationUser[];
}

export interface UserToRemove {
  /**
   * The UUID of the user to remove.
   * @format uuid
   * @example "76275c80-21e2-68bb-1ea2-f8b965a38932"
   */
  uuid: string;
}

export interface LocationUser {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "e4190894-6ab2-4c80-a233-29fa9e87ae90"
   */
  uuid?: string;
  /** @example "pcg38apioc" */
  samsungAccountId?: string;
  /** @example "Mickey Mouse" */
  name?: string;
  /** @example "mickey@mouse.com" */
  email?: string;
  /**
   * Phone number or email. If the phone number is present on the User, this will be the phone number, otherwise falls back to email.
   * @example "mickey@mouse.com"
   */
  display?: string;
}

/** Sub graph for the multihub */
export interface MultiHubSubGraph {
  /**
   * id of the location the hub is in
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** primary hub for the requested hub. Will be itself if the requested hub is the primary. Will be null if the requested hub exists, but is incapable of being either primary or secondary */
  primaryHub?: DeviceIdWrapper;
  /** Secondary hubs connected to the primary hub. Will be empty if there are no secondary hubs */
  secondaryHubs?: DeviceIdWrapper[];
  /** Potential primary hubs for the requested hub. Will be empty if the hub can't become a secondary hub or if there are no primary hubs */
  potentialPrimaryHubs?: DeviceIdWrapper[];
  /**
   * will be INFORMATION_UNAVAILABLE if the hub is still in the onboarding state and hasn't had time to report it's characteristics
   * in case of that response try again after waiting the time specified in the delay field
   */
  status: 'INFORMATION_UNAVAILABLE' | 'INFORMATION_AVAILABLE';
  /** time to wait in seconds until retrying the request in case of status being INFORMATION_UNAVAILABLE. Will be 0 otherwise */
  delay: number;
}

/** wrapper around the deviceId so that we can add more properties later without having to do a breaking change */
export interface DeviceIdWrapper {
  /**
   * The identifier for the device instance.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
}

export interface UpdateEphemeralCapabilityRequest {
  /**
   * The Id of the Component represented by this Swatch.
   * @example "main"
   */
  componentId: string;
  /**
   * The Id of the Capability represented by this Swatch.
   * @example "samsungvd.contentInfo"
   */
  capabilityId: string;
  /** A list of Attributes to update */
  attributes: Attribute[];
}

export interface Attribute {
  /**
   * The id of the attribute to update
   * @example "input"
   */
  attributeId: string;
  /**
   * The ephemeral value to set the attribute to
   * @example "HDMI2"
   */
  value: string;
}

/** pagelist response body */
export type ListPageResponse = Page[];

/**
 * Page object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"page example","title":"Page Example","description":"Page description.","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","countryCodeId":"US","languageCodeId":"en","link":"https://samsung-connect.samsungiotcloud.com/webview/article/ffffd976ffb727001abc7eed?t=1582196980463","serveIfReqLngNotFound":false,"serviceProviderId":"none","updatedAt":1582196980463,"deepLink":"none","weight":9,"articleType":"page","date":"2021-12-22"}
 */
export interface Page {
  document_id: string;
  adminTitle: string;
  title: string;
  description?: string;
  image: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  link: string;
  serveIfReqLngNotFound: boolean;
  /** `othersp`: For other service providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  deepLink:
    | 'none'
    | 'automation'
    | 'scene'
    | 'invitation'
    | 'page'
    | 'fme'
    | 'galaxyx'
    | 'androidauto'
    | 'galaxywatch4'
    | 'findlba'
    | 'seuk_find'
    | 'seuk_voice'
    | 'seuk_personalisation'
    | 'offline_diagnostics';
  /**
   * @min 0
   * @max 100
   */
  weight: number;
  articleType: string;
  /** start date : "2021-06-07" */
  date?: string;
}

/** notificationslist response body */
export type ListNotificationResponse = Notification[];

/**
 * Notification object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"notification example","title":"Notification Example","description":"Notification description.","countryCodeId":"US","date":"2019-07-22","languageCodeId":"en","link":"https://samsung-connect.samsungiotcloud.com/webview/notification/ffffd976ffb727001abc7eed?t=1564378172835","serveIfReqLngNotFound":true,"serviceProviderId":"none","updatedAt":1564378172835,"weight":39}
 */
export interface Notification {
  document_id: string;
  adminTitle: string;
  title: string;
  description?: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  link: string;
  serveIfReqLngNotFound: boolean;
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  date: string;
  /** `othersp`: For other service providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  /**
   * @min 0
   * @max 100
   */
  weight: number;
}

export interface ListDeviceHealthParams {
  /** The locations to filter the results by. */
  locationId?: string[];
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /**
   * GROUP type devices are devices that represent Device Groups. In order to include these devices in the list,
   * a flag needs to be included.
   */
  includeGroups?: boolean;
}

export interface ListDeviceStatusesParams {
  /** The locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** Limit status results to only include capabilities found in the capability query. */
  filterByCapabilities?: boolean;
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /**
   * GROUP type devices are devices that represent Device Groups. In order to include these devices in the list,
   * a flag needs to be included.
   */
  includeGroups?: boolean;
}

export interface ListDeviceGroupStatusesParams {
  /** The locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * If present, only statuses for capabilties in this list will be returned.
   */
  capability?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDeviceGroups?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDeviceGroups?: boolean;
}

export interface ListNotificationNewApiParams {
  /**
   * App querying version.
   * Android app version for `other` device.
   * iOS app version for `ios` device.
   * Valid format `1.1.1``1.1.1.1`
   * @pattern /^\d+(?:\.\d+){2,3}$/
   */
  appVersion?: string;
  /**
   * Providers
   * `othersp`: For other service providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Get contents with moderation state `draft`. This parameter is optional and can be `true` or `false` */
  preview?: 'true' | 'false';
  /** Determines whether data is presented in dark mode or not. This parameter is optional and can be `true` or `false` */
  darkmode?: 'true' | 'false';
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other' | 'windows';
}

export interface ListPageParams {
  /**
   * Content types.
   * `all`: For all 3 content types.
   */
  type: ('howtouse' | 'video' | 'page' | 'stfind' | 'all')[];
  /**
   * App querying version.
   * Android app version for `other` device.
   * iOS app version for `ios` device.
   * Valid format `1.1.1``1.1.1.1`
   * @pattern /^\d+(?:\.\d+){2,3}$/
   */
  appVersion?: string;
  /**
   * Providers
   * `othersp`: For other service providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Get contents with moderation state `draft`. This parameter is optional and can be `true` or `false` */
  preview?: 'true' | 'false';
  /** Determines whether data is presented in dark mode or not. This parameter is optional and can be `true` or `false` */
  darkmode?: 'true' | 'false';
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc) or
   * with Country Code for `DID` content (example: en-US, ko-KR, zh-CN, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other' | 'windows';
}

export interface GetRecommendationsParams {
  /**
   * Id of the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Selected translation code from user device , ex: en-US */
  locale?: string;
}

export interface GetEventRecommendationsParams {
  /**
   * Id of the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Selected translation code from user device , ex: en-US */
  locale?: string;
}

export interface GetPresetAutomationsParams {
  /**
   * Id of the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Scenario type */
  scenario?: 'NO_DEVICE' | 'TIME_DEVICE' | 'DEVICE_NOTIFY' | 'DEVICE_DEVICE' | 'TIME_DEVICE_DEVICE' | 'MEMBER_DEVICE';
}

export interface GetNotificationListParams {
  /**
   * Requester mobile phone device id. mobile device id available on OCF
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  mobileDeviceId: string;
  /** search value, supports "array" multiple value params for UUID only otherwise only single value param. */
  locationId: string[];
  /** Selected translation code from user device , ex: en-US */
  locale?: string;
}

export interface GetRecommendationListParams {
  /** search value, supports "array" multiple value params for UUID only otherwise only single value param. */
  locationId?: string[];
  /** Selected translation code from user device , ex: en-US */
  locale?: string;
}

export interface GetPresetRoutinesParams {
  /**
   * Id of the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Selected translation code from user device , ex: en-US */
  locale?: string;
  /** TestMode for testing and return routine when status are approve and active */
  testMode?: boolean;
}

export interface GetClientRecommendationsParams {
  /** Array of Campaign ID */
  campaignId: string[];
  /**
   * Id of the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** locale for language */
  locale: string;
}

export interface GetRoutineTemplatesParams {
  /**
   * Id of the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Selected translation code from user device , ex: en-US */
  locale?: string;
  /** The person who makes the routine templates. */
  madeBy: 'DISCOVER' | 'EXPLORER' | 'GENERAL';
  size?: number;
  page?: number;
}

export interface GetPiperLogsParams {
  /** The log type. */
  logType?: 'EASYSETUP' | 'HUB' | 'DEVICE';
  /** max number to retrieve items for pagination */
  limit?: number;
  /** The index where the items should be fetched from */
  offset?: number;
  /** A key that is identified by client as a searching option */
  key?: string;
  /**
   * ST device UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * ST location UUID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface GetMobileDevicesParams {
  mobileUniqueId?: string;
}

export interface GetMobileDeviceParams {
  deviceId: string;
}

export interface PutMobileDeviceParams {
  deviceId: string;
}

export interface DeleteMobileParams {
  deviceId: string;
}

export interface PostMobileEventParams {
  deviceId: string;
}

export interface CreateChildParams {
  deviceId: string;
}

export interface GetChildParams {
  deviceId: string;
  /** Id of the child installed in a location. */
  childDeviceId: string;
}

export interface PutMobileChildParams {
  deviceId: string;
  /** Id of the child installed in a location. */
  childDeviceId: string;
}

export interface DeleteChildParams {
  deviceId: string;
  /** Id of the child installed in a location. */
  childDeviceId: string;
}

export interface PostChildEventParams {
  deviceId: string;
  /** Id of the child installed in a location. */
  childDeviceId: string;
}

export interface LinkAccountByTypePayload {
  /** Authorization code returned from Amazon during the initial app to app linking phase */
  amzn_code: string;
  /** The SmartThings client id associated with the Amazon Alexa skill to be installed */
  client_id: string;
  /** Used to enable the skill for the user. */
  activation_uri: string;
  /** The universal link that you specify when you enable app-to-app account linking in the developer console. The Alexa app and LWA redirected the user back to this URL after they acknowledge the account linking request with an Amazon Auth Code.  This endpoint will use this redirect url along with the amazon auth code to get an amazon token. Ensure that this redirect_uri has been added to the latchkey registration. */
  redirect_uri: string;
  /** The skill stage, which depends on whether your skill is published. Until your skill is published, set stage to development. When your skill is published, use live. */
  skill_stage: 'development' | 'live';
  /** The comma separated list of scopes that should be on the token that is sent to Amazon */
  scopes: string;
}

export interface GetMainSwatchParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetMainSwatchByDeviceIdParams {
  deviceId: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetDetailSwatchesByDeviceIdParams {
  deviceId: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ListDeviceGroupSwatchesParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetDeviceGroupSwatchByDeviceGroupIdParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The Device group ID */
  deviceGroupId: string;
}

export interface GetCloudSwatchStatusByLocationIdParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetCloudSwatchStatusByDeviceIdParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  deviceId: string;
}

export type GetCloudSwatchStatusForEphemeralStatusByDeviceIdPayload = UpdateEphemeralCapabilityRequest[];

export interface GetCloudSwatchStatusForEphemeralStatusByDeviceIdParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  deviceId: string;
}

export interface GetWeatherDataParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetLocationUsersParams {
  locationId: string;
}

export type RemoveLocationUserPayload = UserToRemove[];

export interface RemoveLocationUserParams {
  locationId: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://client.smartthings.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Client API
 * @version 4.0
 * @baseUrl https://client.smartthings.com
 *
 * API endpoints for mobile clients
 */
export class ClientV4Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  devices = {
    /**
     * @description Get a paginated list of all device's health status.
     *
     * @tags devices
     * @name ListDeviceHealth
     * @summary Get the health status of all devices
     * @request GET:/devices/health
     * @secure
     */
    listDeviceHealth: (query: ListDeviceHealthParams, params: RequestParams = {}) =>
      this.request<
        {
          items?: DeviceHealthResponse[];
          links?: Links;
        },
        ErrorResponse
      >({
        path: `/devices/health`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of device statuses. If locationIds are provided, the list of Device statuses will be filtered to only those locations.
     *
     * @tags devices
     * @name ListDeviceStatuses
     * @summary Get a list of device statuses
     * @request GET:/devices/status
     * @secure
     */
    listDeviceStatuses: (query: ListDeviceStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceStatusPagedResult, ErrorResponse>({
        path: `/devices/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicegroups = {
    /**
     * @description Get a single device group by Id
     *
     * @tags devicegroups
     * @name GetDeviceGroup
     * @summary Show device group by id
     * @request GET:/devicegroups/{deviceGroupId}
     * @secure
     */
    getDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description update device group with a new set of devices or name. Keep same id.
     *
     * @tags devicegroups
     * @name UpdateDeviceGroup
     * @summary Update device group with a new set of devices or a name. Keep same id.
     * @request PUT:/devicegroups/{deviceGroupId}
     * @secure
     */
    updateDeviceGroup: (deviceGroupId: string, request: DeviceGroupUpdateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete device group based on deviceGroupId
     *
     * @tags devicegroups
     * @name DeleteDeviceGroup
     * @summary Delete device group based on deviceGroupId
     * @request DELETE:/devicegroups/{deviceGroupId}
     * @secure
     */
    deleteDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupDeleteResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of device group statuses with optional filtering by location, capability and group type
     *
     * @tags devicegroups
     * @name ListDeviceGroupStatuses
     * @summary Get a list of device group statuses
     * @request GET:/devicegroups/status
     * @secure
     */
    listDeviceGroupStatuses: (query: ListDeviceGroupStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceGroupStatusPagedResult, ErrorResponse>({
        path: `/devicegroups/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  gettingstarted = {
    /**
     * @description List Notification contents. using string app version
     *
     * @tags Notification
     * @name ListNotificationNewApi
     * @summary List Notifications v3 new
     * @request GET:/gettingstarted/notificationslist/{countryId}/{lngId}/{device}
     */
    listNotificationNewApi: (
      { countryId, lngId, device, ...query }: ListNotificationNewApiParams,
      params: RequestParams = {},
    ) =>
      this.request<ListNotificationResponse, ErrorResponse>({
        path: `/gettingstarted/notificationslist/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Page contents.
     *
     * @tags Page
     * @name ListPage
     * @summary List Page
     * @request GET:/gettingstarted/pagelist/{countryId}/{lngId}/{device}
     */
    listPage: ({ countryId, lngId, device, ...query }: ListPageParams, params: RequestParams = {}) =>
      this.request<ListPageResponse, ErrorResponse>({
        path: `/gettingstarted/pagelist/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  incidents = {
    /**
     * @description Create a new incident. This endpoint will create a new incident, save it to DynamoDB, and invoke another lambda to fetch the cloud data. This endpoint can be invoked with or without a mobile token, in the case where the user has not logged into the mobile phone. If called without the mobile token, cloud logs and cloud data will not be fetched. Incident ID that is returned is to be saved by the mobile client and will be used to link the incident to a JIRA Ticket number.
     *
     * @tags incidents
     * @name CreateIncident
     * @summary Create incident
     * @request POST:/incidents
     * @secure
     */
    createIncident: (PostIncidentJson: IncidentPostBody, params: RequestParams = {}) =>
      this.request<IncidentIdResponse, ErrorResponse>({
        path: `/incidents`,
        method: 'POST',
        body: PostIncidentJson,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes an existing incident by its incidentId
     *
     * @tags incidents
     * @name DeleteIncidentById
     * @summary delete incident
     * @request DELETE:/incidents/{incidentId}
     * @secure
     */
    deleteIncidentById: (incidentId: string, params: RequestParams = {}) =>
      this.request<IncidentIdResponse, ErrorResponse>({
        path: `/incidents/${incidentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  piper = {
    /**
     * @description Get available recommendations from Postino
     *
     * @tags piper
     * @name GetRecommendations
     * @summary Get recommendations
     * @request GET:/piper/recommendations
     * @secure
     */
    getRecommendations: (query: GetRecommendationsParams, params: RequestParams = {}) =>
      this.request<PostinoRecommendationList, any>({
        path: `/piper/recommendations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get available event driven recommendations from Postino
     *
     * @tags piper
     * @name GetEventRecommendations
     * @summary Get event driven recommendations
     * @request GET:/piper/event-recommendations
     * @secure
     */
    getEventRecommendations: (query: GetEventRecommendationsParams, params: RequestParams = {}) =>
      this.request<PostinoRecommendationList, any>({
        path: `/piper/event-recommendations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Change recommendation preferences
     *
     * @tags piper
     * @name ChangeRecommendationPreference
     * @summary Change recommendation preferences
     * @request POST:/piper/recommendations/preferences
     * @secure
     */
    changeRecommendationPreference: (PreferenceRequest: PostinoRecommendationPreference, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/recommendations/preferences`,
        method: 'POST',
        body: PreferenceRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get preset automations for a user
     *
     * @tags piper
     * @name GetPresetAutomations
     * @summary Get preset automations
     * @request GET:/piper/automations
     * @secure
     */
    getPresetAutomations: (query: GetPresetAutomationsParams, params: RequestParams = {}) =>
      this.request<PostinoPresetAutomationList, any>({
        path: `/piper/automations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get push recommendation status.
     *
     * @tags piper
     * @name GetNotificationStatus
     * @summary Get push recommendation status
     * @request GET:/piper/notifications/{notificationId}/status
     * @secure
     */
    getNotificationStatus: (notificationId: string, params: RequestParams = {}) =>
      this.request<NotificationStatus, ErrorResponse>({
        path: `/piper/notifications/${notificationId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get available push recommendations list from Postino
     *
     * @tags piper
     * @name GetNotificationList
     * @summary Get push recommendation list
     * @request GET:/piper/notifications/history
     * @secure
     */
    getNotificationList: (query: GetNotificationListParams, params: RequestParams = {}) =>
      this.request<PostinoNotificationList, any>({
        path: `/piper/notifications/history`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a historical list of recommendation events for given location ids. If locationIds are empty then returns historical recommendation events for all locations for the oauth user.
     *
     * @tags piper
     * @name GetRecommendationList
     * @summary Get a historical list of recommendation events for given location ids
     * @request GET:/piper/recommendations/history
     * @secure
     */
    getRecommendationList: (query: GetRecommendationListParams, params: RequestParams = {}) =>
      this.request<RecommendationListResponse, any>({
        path: `/piper/recommendations/history`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get preset routines from Postino
     *
     * @tags piper
     * @name GetPresetRoutines
     * @summary Get preset routines
     * @request GET:/piper/preset-routines
     * @secure
     */
    getPresetRoutines: (query: GetPresetRoutinesParams, params: RequestParams = {}) =>
      this.request<PostinoPresetRoutinesList, any>({
        path: `/piper/preset-routines`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Client Triggered Recommendation Campaign's on-air status
     *
     * @tags piper
     * @name GetClientRecommendationsStatus
     * @summary Get Client Triggered Recommendation Campaign's on-air status
     * @request GET:/piper/client-recommendations/{campaignId}/status
     * @secure
     */
    getClientRecommendationsStatus: (campaignId: string, params: RequestParams = {}) =>
      this.request<ClientRecommendationStatus, ErrorResponse>({
        path: `/piper/client-recommendations/${campaignId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get available client triggered recommendations
     *
     * @tags piper
     * @name GetClientRecommendations
     * @summary Get Client Triggered Recommendation Campaign's and Recommendation's
     * @request GET:/piper/client-recommendations
     * @secure
     */
    getClientRecommendations: (query: GetClientRecommendationsParams, params: RequestParams = {}) =>
      this.request<PostinoClientRecommendationList, any>({
        path: `/piper/client-recommendations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get routine templates from Postino by madeBy
     *
     * @tags piper
     * @name GetRoutineTemplates
     * @summary Get routine templates by madeBy
     * @request GET:/piper/routine-templates
     * @secure
     */
    getRoutineTemplates: (query: GetRoutineTemplatesParams, params: RequestParams = {}) =>
      this.request<PostinoPaginatedPresetResponse, any>({
        path: `/piper/routine-templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send client logs to data platform piper service. NOTE: The payload is required to be compressed with gzip.
     *
     * @tags piper
     * @name PostPiperLogs
     * @summary Post client logs
     * @request POST:/piper/logs
     * @secure
     */
    postPiperLogs: (PiperLogsRequest: PiperLogsRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/logs`,
        method: 'POST',
        body: PiperLogsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get client logs from data platform piper service
     *
     * @tags piper
     * @name GetPiperLogs
     * @summary Retrieve the list of client logs
     * @request GET:/piper/logs
     * @secure
     */
    getPiperLogs: (query: GetPiperLogsParams, params: RequestParams = {}) =>
      this.request<PagedPiperGetLogsResponse, ErrorResponse>({
        path: `/piper/logs`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send hub logs to data platform piper service. Pre-signed URL returned to client for uploading the logs.
     *
     * @tags piper
     * @name PostPiperHubLogs
     * @summary Post hub logs file
     * @request POST:/piper/hub/logs
     * @secure
     */
    postPiperHubLogs: (PiperHubLogsRequest: PiperHubLogsRequest, params: RequestParams = {}) =>
      this.request<PiperHubLogsResponse, ErrorResponse>({
        path: `/piper/hub/logs`,
        method: 'POST',
        body: PiperHubLogsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send device logs to data platform piper service. Pre-signed URL returned to client for uploading the logs.
     *
     * @tags piper
     * @name PostPiperDeviceLogs
     * @summary Post device logs file
     * @request POST:/piper/device/logs
     * @secure
     */
    postPiperDeviceLogs: (PiperDeviceLogsRequest: PiperDeviceLogsRequest, params: RequestParams = {}) =>
      this.request<PiperDeviceLogsResponse, ErrorResponse>({
        path: `/piper/device/logs`,
        method: 'POST',
        body: PiperDeviceLogsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send client click events to data platform piper service. NOTE: The payload is required to be compressed with gzip. The maximum gzip size must be less than 1,000,000 bytes.
     *
     * @tags piper
     * @name PostPiperClicks
     * @summary Post client click events
     * @request POST:/piper/clicks
     * @secure
     */
    postPiperClicks: (PiperClicksRequest: PiperClicksRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/clicks`,
        method: 'POST',
        body: PiperClicksRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Send native app command history events to data platform piper service. NOTE: The payload is required to be compressed with gzip. The maximum gzip size must be less than 1,000,000 bytes.
     *
     * @tags piper
     * @name PostPiperHistory
     * @summary Post native app command history events
     * @request POST:/piper/history
     * @secure
     */
    postPiperHistory: (PiperHistoryRequest: PiperHistoryRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/history`,
        method: 'POST',
        body: PiperHistoryRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Send client user activities events to data platform piper service. NOTE: The payload is required to be compressed with gzip. The maximum gzip size must be less than 1,000,000 bytes.
     *
     * @tags piper
     * @name PostPiperActivities
     * @summary Post client user activities events
     * @request POST:/piper/activities
     * @secure
     */
    postPiperActivities: (PiperActivitiesRequest: PiperActivitiesRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/activities`,
        method: 'POST',
        body: PiperActivitiesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  mobiledevices = {
    /**
     * @description Create a new Mobile Device
     *
     * @tags mobiledevices
     * @name CreateMobile
     * @request POST:/mobiledevices
     * @secure
     */
    createMobile: (requestBody: CreateMobileRequest, params: RequestParams = {}) =>
      this.request<MobileDevice, ErrorResponse>({
        path: `/mobiledevices`,
        method: 'POST',
        body: requestBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the list of Mobile Devices belonging to the user.
     *
     * @tags mobiledevices
     * @name GetMobileDevices
     * @request GET:/mobiledevices
     * @secure
     */
    getMobileDevices: (query: GetMobileDevicesParams, params: RequestParams = {}) =>
      this.request<PagedMobileDevices, ErrorResponse>({
        path: `/mobiledevices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the details of the Mobile Device.
     *
     * @tags mobiledevices
     * @name GetMobileDevice
     * @request GET:/mobiledevices/{deviceId}
     * @secure
     */
    getMobileDevice: ({ deviceId, ...query }: GetMobileDeviceParams, params: RequestParams = {}) =>
      this.request<MobileDevice, ErrorResponse>({
        path: `/mobiledevices/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing Mobile Device.
     *
     * @tags mobiledevices
     * @name PutMobileDevice
     * @request PUT:/mobiledevices/{deviceId}
     * @secure
     */
    putMobileDevice: (
      { deviceId, ...query }: PutMobileDeviceParams,
      requestBody: UpdateMobileRequest,
      params: RequestParams = {},
    ) =>
      this.request<MobileDevice, ErrorResponse>({
        path: `/mobiledevices/${deviceId}`,
        method: 'PUT',
        query: query,
        body: requestBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description delete an existing Mobile Device.
     *
     * @tags mobiledevices
     * @name DeleteMobile
     * @request DELETE:/mobiledevices/{deviceId}
     * @secure
     */
    deleteMobile: ({ deviceId, ...query }: DeleteMobileParams, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/mobiledevices/${deviceId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create events for Mobile Device.
     *
     * @tags mobiledevices
     * @name PostMobileEvent
     * @request POST:/mobiledevices/{deviceId}/deviceEvents
     * @secure
     */
    postMobileEvent: (
      { deviceId, ...query }: PostMobileEventParams,
      requestBody: CapabilityEvents,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityEventsResponse, ErrorResponse>({
        path: `/mobiledevices/${deviceId}/deviceEvents`,
        method: 'POST',
        query: query,
        body: requestBody,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create location specific child devices.
     *
     * @tags mobiledevices
     * @name CreateChild
     * @request POST:/mobiledevices/{deviceId}/children
     * @secure
     */
    createChild: (
      { deviceId, ...query }: CreateChildParams,
      requestBody: CreateMobileChildrenRequest,
      params: RequestParams = {},
    ) =>
      this.request<MobileChildren, ErrorResponse>({
        path: `/mobiledevices/${deviceId}/children`,
        method: 'POST',
        query: query,
        body: requestBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a child device by id.
     *
     * @tags mobiledevices
     * @name GetChild
     * @request GET:/mobiledevices/{deviceId}/children/{childDeviceId}
     * @secure
     */
    getChild: ({ childDeviceId, deviceId, ...query }: GetChildParams, params: RequestParams = {}) =>
      this.request<MobileChild, ErrorResponse>({
        path: `/mobiledevices/${deviceId}/children/${childDeviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing Mobile Child Device. Fields that are null are ignored and will result in a partial update.
     *
     * @tags mobiledevices
     * @name PutMobileChild
     * @request PUT:/mobiledevices/{deviceId}/children/{childDeviceId}
     * @secure
     */
    putMobileChild: (
      { childDeviceId, deviceId, ...query }: PutMobileChildParams,
      requestBody: UpdateMobileChild,
      params: RequestParams = {},
    ) =>
      this.request<MobileChild, ErrorResponse>({
        path: `/mobiledevices/${deviceId}/children/${childDeviceId}`,
        method: 'PUT',
        query: query,
        body: requestBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description delete an existing Mobile Child.
     *
     * @tags mobiledevices
     * @name DeleteChild
     * @request DELETE:/mobiledevices/{deviceId}/children/{childDeviceId}
     * @secure
     */
    deleteChild: ({ childDeviceId, deviceId, ...query }: DeleteChildParams, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/mobiledevices/${deviceId}/children/${childDeviceId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create events for a child installed in a location
     *
     * @tags mobiledevices
     * @name PostChildEvent
     * @request POST:/mobiledevices/{deviceId}/children/{childDeviceId}/deviceEvents
     * @secure
     */
    postChildEvent: (
      { childDeviceId, deviceId, ...query }: PostChildEventParams,
      requestBody: CapabilityEvents,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityEventsResponse, ErrorResponse>({
        path: `/mobiledevices/${deviceId}/children/${childDeviceId}/deviceEvents`,
        method: 'POST',
        query: query,
        body: requestBody,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  link = {
    /**
     * @description Supports Amazon's app to app linking flow [described here](https://developer.amazon.com/en-US/docs/alexa/account-linking/app-to-app-account-linking.html).  The response from step 6 is directly proxied back as a response to the original request. Amazon error responses may be found [here](https://developer.amazon.com/en-US/docs/alexa/account-linking/app-to-app-account-linking.html#error-skill-activation-api)
     *
     * @tags Account Linking
     * @name LinkAccountByType
     * @summary App to App Linking of an Amazon to SmartThings account. Response is proxied back from Amazon
     * @request POST:/link/amazon
     */
    linkAccountByType: (data: LinkAccountByTypePayload, params: RequestParams = {}) =>
      this.request<LinkSuccessResponse, LinkErrorResponse>({
        path: `/link/amazon`,
        method: 'POST',
        body: data,
        type: ContentType.UrlEncoded,
        format: 'json',
        ...params,
      }),
  };
  swatches = {
    /**
     * @description Get a list of MainSwatches
     *
     * @tags swatches
     * @name GetMainSwatch
     * @summary Get a list of MainSwatches
     * @request GET:/swatches/devices/main
     * @secure
     */
    getMainSwatch: (query: GetMainSwatchParams, params: RequestParams = {}) =>
      this.request<WrappedMainSwatchItem[], void | ErrorResponse>({
        path: `/swatches/devices/main`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a MainSwatch for a deviceId
     *
     * @tags swatches
     * @name GetMainSwatchByDeviceId
     * @summary Get a MainSwatch for a deviceId
     * @request GET:/swatches/devices/{deviceId}/main
     * @secure
     */
    getMainSwatchByDeviceId: ({ deviceId, ...query }: GetMainSwatchByDeviceIdParams, params: RequestParams = {}) =>
      this.request<WrappedMainSwatchItem, void | ErrorResponse>({
        path: `/swatches/devices/${deviceId}/main`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of DetailSwatches for a deviceId
     *
     * @tags swatches
     * @name GetDetailSwatchesByDeviceId
     * @summary Get a list of DetailSwatches for a deviceId
     * @request GET:/swatches/devices/{deviceId}/details
     * @secure
     */
    getDetailSwatchesByDeviceId: (
      { deviceId, ...query }: GetDetailSwatchesByDeviceIdParams,
      params: RequestParams = {},
    ) =>
      this.request<WrappedDetailSwatchItem[], void | ErrorResponse>({
        path: `/swatches/devices/${deviceId}/details`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of Device Group Swatches
     *
     * @tags swatches
     * @name ListDeviceGroupSwatches
     * @summary Get a list of Device Group Swatches
     * @request GET:/swatches/deviceGroups
     * @secure
     */
    listDeviceGroupSwatches: (query: ListDeviceGroupSwatchesParams, params: RequestParams = {}) =>
      this.request<DeviceGroupSwatch[], void | ErrorResponse>({
        path: `/swatches/deviceGroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a DeviceGroup for a deviceGroupId
     *
     * @tags swatches
     * @name GetDeviceGroupSwatchByDeviceGroupId
     * @summary Get a DeviceGroup for a deviceGroupId
     * @request GET:/swatches/deviceGroups/{deviceGroupId}
     * @secure
     */
    getDeviceGroupSwatchByDeviceGroupId: (
      { deviceGroupId, ...query }: GetDeviceGroupSwatchByDeviceGroupIdParams,
      params: RequestParams = {},
    ) =>
      this.request<DeviceGroupSwatch, void | ErrorResponse>({
        path: `/swatches/deviceGroups/${deviceGroupId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of Cloud statuses for main swatches
     *
     * @tags swatches
     * @name GetCloudSwatchStatusByLocationId
     * @summary Get a list of Cloud statuses for main swatches
     * @request GET:/swatches/cloud/status
     * @secure
     */
    getCloudSwatchStatusByLocationId: (query: GetCloudSwatchStatusByLocationIdParams, params: RequestParams = {}) =>
      this.request<CloudSwatchStatus[], ErrorResponse>({
        path: `/swatches/cloud/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get status for Cloud MainSwatch by deviceId
     *
     * @tags swatches
     * @name GetCloudSwatchStatusByDeviceId
     * @summary Get status for Cloud MainSwatch by deviceId
     * @request GET:/swatches/cloud/{deviceId}/status
     * @secure
     */
    getCloudSwatchStatusByDeviceId: (
      { deviceId, ...query }: GetCloudSwatchStatusByDeviceIdParams,
      params: RequestParams = {},
    ) =>
      this.request<CloudSwatchStatus, ErrorResponse>({
        path: `/swatches/cloud/${deviceId}/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Cloud MainSwatch for ephemeral status by deviceId
     *
     * @tags swatches
     * @name GetCloudSwatchStatusForEphemeralStatusByDeviceId
     * @summary Get Cloud MainSwatch for ephemeral status by deviceId
     * @request PUT:/swatches/cloud/{deviceId}/status
     * @secure
     */
    getCloudSwatchStatusForEphemeralStatusByDeviceId: (
      { deviceId, ...query }: GetCloudSwatchStatusForEphemeralStatusByDeviceIdParams,
      capabilitiesToUpdate: GetCloudSwatchStatusForEphemeralStatusByDeviceIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<CloudSwatchStatus, ErrorResponse>({
        path: `/swatches/cloud/${deviceId}/status`,
        method: 'PUT',
        query: query,
        body: capabilitiesToUpdate,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  weatherdata = {
    /**
     * @description Get weather data for a location
     *
     * @tags weatherdata
     * @name GetWeatherData
     * @summary Get Weather Data for a location
     * @request GET:/weatherdata
     * @secure
     */
    getWeatherData: (query: GetWeatherDataParams, params: RequestParams = {}) =>
      this.request<WeatherData, any>({
        path: `/weatherdata`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  locations = {
    /**
     * @description This endpoint merely proxies to SIAM.  You should be using https://librarian-regionals.smartthingsgdev.com/api/siam.st.internal.v20200320#operation/queryUsers for lower latency.
     *
     * @tags Locations
     * @name GetLocationUsers
     * @summary This endpoint merely proxies to SIAM.  You should be using https://librarian-regionals.smartthingsgdev.com/api/siam.st.internal.v20200320#operation/queryUsers for lower latency.
     * @request GET:/locations/{locationId}/users
     * @secure
     */
    getLocationUsers: ({ locationId, ...query }: GetLocationUsersParams, params: RequestParams = {}) =>
      this.request<LocationUsersResponse, any>({
        path: `/locations/${locationId}/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove a user from a location. If the caller is the owner of the location then they may remove any member but themselves. If the caller is not an owner, than they may only remove themsleves.
     *
     * @tags shepherd, locations
     * @name RemoveLocationUser
     * @summary Remove users from a location
     * @request PUT:/locations/{locationId}/users
     * @secure
     */
    removeLocationUser: (
      { locationId, ...query }: RemoveLocationUserParams,
      usersToRemove: RemoveLocationUserPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/locations/${locationId}/users`,
        method: 'PUT',
        query: query,
        body: usersToRemove,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  hubinfo = {
    /**
     * @description Determines primary hub for a hub, eventual secondary hubs for the primary hub and, if there are other hubs in the location that can be primary hubs for this hub, potentialPrimaryHubs
     *
     * @tags hubinfo
     * @name GetMultihubSubgraph
     * @summary Returns Multi Hub SubGraph
     * @request GET:/hubinfo/{hubId}/hubgraph
     * @secure
     */
    getMultihubSubgraph: (hubId: string, params: RequestParams = {}) =>
      this.request<MultiHubSubGraph, ErrorResponse>({
        path: `/hubinfo/${hubId}/hubgraph`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
